export type TranslationKey = string;

// The structure is { key: [Polish value, English value] }
export const translations: Record<TranslationKey, [string, string]> = {
  // Navigation
  'nav.services': ['Usługi', 'Services'],
  'nav.ourProjects': ['Nasze realizacje', 'Our Projects'],
  'nav.about': ['O nas', 'About us'],
  'nav.contact': ['Kontakt', 'Contact'],
  'nav.estimateProject': ['Wyceń projekt', 'Estimate project'],

  // Services
  'services.medtech.title': ['Medtech', 'Medtech'],
  'services.medtech.subtitle': [
    'Kreuj przyszłość medycyny z ekspertami Appotype',
    'Shape the future of medicine with Appotype experts',
  ],
  'services.enterprise.title': ['Enterprise', 'Enterprise'],
  'services.enterprise.subtitle': [
    'Profesjonalne wsparcie IT i audyt projektu',
    'Professional IT support and project audit',
  ],
  'services.ai.title': ['Artificial intelligence', 'Artificial intelligence'],
  'services.ai.subtitle': [
    'Wykorzystaj AI do zdobycia przewagi konkurencyjnej',
    'Use AI to gain competitive advantage',
  ],
  'services.softwareAgency.title': ['Software Agency', 'Software Agency'],
  'services.softwareAgency.subtitle': [
    'Oprogramowanie, które robi różnicę',
    'Software that makes a difference',
  ],

  // Language toggle
  'language.toggle': ['PL', 'EN'],

  // Home Page - Hero Section
  'home.hero.title': ['Software Agency', 'Software Agency'],
  'home.hero.subtitle': [
    'Tworzymy oprogramowanie, które automatyzuje procesy i zwiększa konkurencyjność Twojej firmy.',
    "We create software that automates processes and increases your company's competitiveness.",
  ],
  'home.hero.button.meeting': ['Umów się na spotkanie', 'Schedule a meeting'],
  'home.hero.button.services': ['Sprawdź nasze usługi', 'Check our services'],

  // Services Section
  'services.section.title': ['Jak możemy Ci pomóc?', 'How can we help you?'],
  'services.section.subtitle': [
    'Tworzymy złożone aplikacje z pasją i dbałością o najwyższą jakość. Projektujemy, implementujemy oraz audytujemy każdy etap realizacji. Wybierz obszar, który Cię interesuje:',
    'We create complex applications with passion and attention to the highest quality. We design, implement and audit every stage of implementation. Choose the area you are interested in:',
  ],

  'services.medtech.details.title': [
    'Kreuj przyszłość medycyny z ekspertami Appotype',
    'Shape the future of medicine with Appotype experts',
  ],
  'services.medtech.details.subtitle': [
    'Projektujemy skalowalne systemy medyczne zgodne z MDR i FDA. Gotowe na przyszłość branży medtech.',
    'We design scalable medical systems compliant with MDR and FDA. Ready for the future of the medtech industry.',
  ],
  'services.medtech.details.button': ['Sprawdź, jak możemy pomóc', 'See how we can help'],
  'services.medtech.details.services': ['Nasze usługi:', 'Our services:'],
  'services.medtech.details.service1': ['Personalizowane modele AI', 'Personalized AI models'],
  'services.medtech.details.service2': ['Data science', 'Data science'],
  'services.medtech.details.service3': [
    'Analiza danych w czasie rzeczywistym',
    'Real-time data analysis',
  ],

  'services.ai.details.title': [
    'Wykorzystaj AI do zdobycia przewagi konkurencyjnej',
    'Use AI to gain competitive advantage',
  ],
  'services.ai.details.subtitle': [
    'Dostosujemy rozwiązania AI do Twoich potrzeb. Od standardowych wdrożeń po trenowanie własnych modeli AI.',
    'We will adapt AI solutions to your needs. From standard implementations to training your own AI models.',
  ],
  'services.ai.details.button': [
    'Poznaj zalety wdrożenia AI',
    'Learn the benefits of AI implementation',
  ],
  'services.ai.details.services': ['Nasze usługi:', 'Our services:'],
  'services.ai.details.service1': ['Project management', 'Project management'],
  'services.ai.details.service2': ['Audyt', 'Audit'],
  'services.ai.details.service3': ['Nadzór projektu', 'Project supervision'],

  'services.enterprise.details.title': [
    'Profesjonalne wsparcie IT i audyt projektu',
    'Professional IT support and project audit',
  ],
  'services.enterprise.details.subtitle': [
    'Dbamy o zgodność Twojego projektu z założeniami. Na każdym etapie realizacji.',
    'We ensure your project compliance with assumptions. At every stage of implementation.',
  ],
  'services.enterprise.details.button': ['Zobacz nasze rozwiązania', 'See our solutions'],
  'services.enterprise.details.services': ['Nasze usługi:', 'Our services:'],
  'services.enterprise.details.service1': ['Proof of Concept', 'Proof of Concept'],
  'services.enterprise.details.service2': ['MVP', 'MVP'],
  'services.enterprise.details.service3': ['Rozwój aplikacji', 'Application development'],

  'services.softwareAgency.details.title': [
    'Innowacyjne rozwiązania dla ambitnych projektów',
    'Innovative solutions for ambitious projects',
  ],
  'services.softwareAgency.details.subtitle': [
    'Tworzymy skalowalne i bezpieczne aplikacje. Aplikacje webowe, mobilne oraz integracje z IoT. Przekonaj się, jak wiele możemy razem osiągnąć.',
    'We create scalable and secure applications. Web, mobile, and IoT integrations. Discover how much we can achieve together.',
  ],
  'services.softwareAgency.details.button': ['Sprawdź nasze podejście', 'Check our approach'],

  // Calculator Section
  'calculator.title': [
    'Chcesz poznać koszt swojego projektu?',
    'Want to know the cost of your project?',
  ],
  'calculator.subtitle': [
    'Skorzystaj z naszego kalkulatora, aby szybko oszacować wartość inwestycji.',
    'Use our calculator to quickly estimate the value of your investment.',
  ],
  'calculator.button': ['Przejdź do kalkulatora wycen', 'Go to the pricing calculator'],

  // Stats Section
  'stats.title': [
    'Zaufaj ekspertom, którzy tworzą profesjonalne rozwiązania',
    'Trust experts who create professional solutions',
  ],
  'stats.subtitle': [
    'Nasze doświadczenie i wiedza to fundament, na którym budujemy innowacyjne rozwiązania. Łączymy pasję, doświadczenie i nowoczesne technologie.',
    'Our experience and knowledge are the foundation on which we build innovative solutions. We combine passion, experience and modern technologies.',
  ],

  'stats.item1.number': ['50+', '50+'],
  'stats.item1.label': ['projektów', 'projects'],
  'stats.item2.number': ['200+', '200+'],
  'stats.item2.label': ['wersji aplikacji mobilnych', 'mobile application versions'],
  'stats.item3.number': ['10+', '10+'],
  'stats.item3.label': [
    'udanych realizacji z zakresu Medtech',
    'successful Medtech implementations',
  ],
  'stats.item4.number': ['20,000+', '20,000+'],
  'stats.item4.label': ['commitów kodu', 'code commits'],
  'stats.item5.number': ['50,000+', '50,000+'],
  'stats.item5.label': ['godzin programowania', 'programming hours'],
  'stats.item6.number': ['1,000+', '1,000+'],
  'stats.item6.label': ['godzin spotkań z klientami', 'client meetings hours'],

  // Carousel Section
  'carousel.title': [
    'Za co klienci cenią nas najbardziej?',
    'What do clients value most about us?',
  ],
  'carousel.reviews.title': ['Appotype Reviews', 'Appotype Reviews'],
  'carousel.reviews.check': ['Sprawdź nasz profil na Clutch', 'Check our profile on Clutch'],

  'carousel.centerTexts.1': [
    '... posiada ekspercką wiedzę i doświadczenie',
    '... has expert knowledge and experience',
  ],
  'carousel.centerTexts.2': ['... tworzy innowacyjne rozwiązania', '... creates innovative solutions'],
  'carousel.centerTexts.3': ['... zapewnia profesjonalne wsparcie', '... provides professional support'],
  'carousel.centerTexts.4': ['... gwarantuje najwyższą jakość', '... guarantees the highest quality'],
  'carousel.centerTexts.5': ['... jest proaktywnym partnerem', '... is a proactive partner'],

  'carousel.testimonial.1': [
    'Podczas pracy nad Brasterem Mateusz wykazał się doskonałą znajomością aplikacji mobilnych oraz zrozumieniem zagadnień związanych ze sprzętem i firmware. Jest kreatywny, zorganizowany i można na nim polegać.',
    'While working on Braster, Mateusz demonstrated excellent knowledge of mobile applications and understanding of hardware and firmware issues. He is creative, organized, and reliable.',
  ],
  'carousel.testimonial.2': [
    'CEO to prawdziwy ekspert jeśli chodzi o aplikacje mobilne. Jestem bardzo zadowolony ze współpracy i poleciłbym ją każdemu!',
    'The CEO is a true expert when it comes to mobile applications. I am very satisfied with the cooperation and would recommend it to anyone!',
  ],
  'carousel.testimonial.3': [
    'Pracowaliśmy przy dwóch projektach, w których urządzenia medyczne i aplikacje mobilne połączyły się w nowoczesne rozwiązania telemedyczne. Bogate doświadczenie i profesjonalne podejście sprawiają, że Appotype jest naszym partnerem w tworzeniu aplikacji mobilnych i internetowych.',
    'We worked on two projects where medical devices and mobile applications combined into modern telemedicine solutions. Their rich experience and professional approach make Appotype our partner in creating mobile and web applications.',
  ],
  'carousel.testimonial.4': [
    'System działa dobrze i spełnia wszystkie wymagania regulacyjne. Audyt jednostki notyfikowanej przebiegł pomyślnie.',
    'The system works well and meets all regulatory requirements. The audit of the notified body went successfully.',
  ],
  'carousel.testimonial.5': [
    'Appotype wykazał się dużym zaangażowaniem i elastycznością. Szybko reagowali na zmiany wprowadzane z naszej strony i proaktywnie angażowali się w ustalanie najlepszych rozwiązań dla naszych celów.',
    'Appotype showed great commitment and flexibility. They quickly responded to changes we made and were proactively involved in establishing the best solutions for our goals.',
  ],
  'carousel.testimonial.6': [
    'Firma jest bardzo elastyczna i ma perfekcyjną komunikację.',
    'The company is very flexible and has perfect communication.',
  ],
  'carousel.testimonial.7': [
    '(...) było to bardzo udane, a nowa wersja naszej aplikacji na iOS została ukończona bardzo szybko.',
    '(...) it was very successful, and the new version of our iOS application was completed very quickly.',
  ],
  'carousel.testimonial.8': [
    'Byli bardzo samodzielni, szybcy i mieli adekwatną komunikację.',
    'They were very independent, fast, and had adequate communication.',
  ],
  'carousel.testimonial.9': [
    'Appotype proaktywnie poszukiwał i proponował alternatywy w celu osiągnięcia oczekiwanego celu',
    'Appotype proactively sought and proposed alternatives to reach the expected goal',
  ],
  'carousel.testimonial.10': [
    'Są reaktywni, proaktywni i zawsze upewniają się, że modele AI działają na najwyższym poziomie',
    'They are responsive, proactive, and always ensure the AI models perform at their best.',
  ],
  
  // Case Study Section
  'caseStudy.title': ['Sprawdź nasze projekty - case study', 'Check our projects - case studies'],
  'caseStudy.subtitle': [
    'Zobacz, jak wykorzystujemy technologię. W ten sposób pomagamy naszym klientom utrzymać lub zdobyć status lidera branży.',
    'See how we use technology. This is how we help our clients maintain or achieve industry leader status.',
  ],

  'caseStudy.listTitle.1': ['Aplikacja edukacyjna - DiL', 'Educational application - DiL'],
  'caseStudy.title.1': [
    'Narzędzie wspierające diagnozowanie depresji',
    'Tool supporting the diagnosis of depression',
  ],
  'caseStudy.description.1': [
    'W ramach współpracy z Angelini Pharma stworzyliśmy aplikację "Diagnozuj i Lecz" – narzędzie wspierające lekarzy oraz osoby rozpoznające wczesne objawy depresji. Głównym celem projektu jest zwiększenie świadomości w obszarze zdrowia psychicznego.',
    'As part of our cooperation with Angelini Pharma, we created the "Diagnozuj i Lecz" application - a tool supporting doctors and people recognizing early symptoms of depression. The main goal of the project is to increase awareness in the area of mental health.',
  ],

  'caseStudy.title.2': ['Aplikacja SmartMedics', 'SmartMedics Application'],
  'caseStudy.description.2': [
    'Sercem systemu SmartMedics ECG jest najmniejszy na świecie 12-odprowadzeniowy EKG. Zapewnienie płynnego przesyłania danych w czasie rzeczywistym przy stosunkowo niskiej przepustowości tej technologii transmisji danych było niemałym wyzwaniem. Aplikacja mobilna oferuje wiele funkcji związanych z zarządzaniem pacjentami oraz przeprowadzanymi na nich badaniami.',
    "The heart of the SmartMedics ECG system is the world's smallest 12-lead ECG. Ensuring smooth real-time data transmission with the relatively low bandwidth of this data transmission technology was no small challenge. The mobile application offers many features related to patient management and examinations performed on them.",
  ],

  'caseStudy.title.3': [
    'Medinice - Innowacje w kardiologii',
    'Medinice - Innovations in cardiology',
  ],
  'caseStudy.description.3': [
    'Medinice, lider w innowacyjnych technologiach medycznych, zwróciło się do nas z kluczowym wyzwaniem: przeprowadzenie audytu aplikacji PacePress, zaawansowanego narzędzia kardiologicznego.',
    'Medinice, a leader in innovative medical technologies, came to us with a key challenge: to conduct an audit of the PacePress application, an advanced cardiological tool.',
  ],

  'caseStudy.button': ['Poznaj pełne case study', 'See the full case study'],

  // Contact Section
  'contact.title': [
    'Porozmawiajmy o technologii, która wspiera Twój biznes',
    "Let's talk about technology that supports your business",
  ],
  'contact.subtitle': [
    'Skontaktuj się z nami. Wspólnie odkryjemy, jak technologia może wspierać Twój biznes.',
    'Contact us. Together we will discover how technology can support your business.',
  ],

  'contact.card1.title': ['Spotkanie online', 'Online meeting'],
  'contact.card1.description': [
    'Zaplanuj spotkanie w naszym kalendarzu. Omówimy Twoje wyzwania technologiczne.',
    'Schedule a meeting in our calendar. We will discuss your technological challenges.',
  ],
  'contact.card1.button': ['Sprawdź kalendarz', 'Check calendar'],

  'contact.card2.title': ['Zadzwoń do nas', 'Call us'],
  'contact.card2.description': [
    'Podziel się szczegółami swojego projektu podczas rozmowy telefonicznej.',
    'Share the details of your project during a phone call.',
  ],
  'contact.card2.button': ['Wyświetl numer', 'Show number'],

  'contact.card3.title': ['Wyceń swój projekt', 'Estimate your project'],
  'contact.card3.description': [
    'Odpowiedz na kilka pytań i uzyskaj szacunkową wycenę swojego projektu.',
    'Answer a few questions and get an estimated cost for your project.',
  ],
  'contact.card3.button': ['Skorzystaj z kalkulatora', 'Use the calculator'],

  // Medtech Page
  'medtech.hero.title': [
    'Oprogramowanie Medtech – Twoje innowacje w dobrych rękach',
    'Medtech Software - Your innovations in good hands',
  ],
  'medtech.hero.subtitle': [
    'Pomagamy naszym partnerom przejść płynnie cały proces. Wspólnie opracowujemy koncepcję, wdrażamy produkty na rynek i wspieramy certyfikację wyrobów medycznych.',
    'We help our partners go through the entire process smoothly. Together we develop the concept, launch products to the market, and support medical device certification.',
  ],
  'medtech.industry.title': [
    'Pochodzisz z branży medycznej i...',
    'You come from the medical industry and...',
  ],
  'medtech.industry.card1': [
    'Szukasz partnera technologicznego godnego zaufania.',
    'You are looking for a trustworthy technology partner.',
  ],
  'medtech.industry.card2': [
    'Chcesz wdrożyć produkt na rynek zgodnie ze standardami branżowymi.',
    'You want to launch a product to the market in accordance with industry standards.',
  ],
  'medtech.industry.card3': [
    'Potrzebujesz wsparcia w certyfikacji wyrobów medycznych.',
    'You need support in medical device certification.',
  ],

  'medtech.howWeWork.title': ['Jak wspieramy Twój rozwój?', 'How do we support your development?'],
  'medtech.howWeWork.step1.title': [
    'Projektujemy aplikacje medyczne',
    'We design medical applications',
  ],
  'medtech.howWeWork.step1.description1': [
    'Rozumiemy specyfikę branży medycznej. Nasze doświadczenie pozwala nam na projektowanie skalowalnych i intuicyjnych aplikacji. Piszemy je zgodnie z rygorystycznymi wymogami prawnymi i certyfikacyjnymi.',
    'We understand the specifics of the medical industry. Our experience allows us to design scalable and intuitive applications. We write them in accordance with rigorous legal and certification requirements.',
  ],
  'medtech.howWeWork.step1.description2': [
    'Wspieramy wdrażanie procedur zgodnych z europejskim rozporządzeniem MDR. Mamy też na uwadze projektowanie zgodne z wytycznymi WCAG, co zwiększa dostępność aplikacji o ponad 15%.',
    'We support the implementation of procedures compliant with the European MDR regulation. We also keep in mind design compliant with WCAG guidelines, which increases application accessibility by over 15%.',
  ],

  'medtech.howWeWork.step2.title': [
    'Tworzymy oprogramowanie zgodne z rygorystycznymi normami',
    'We create software compliant with rigorous standards',
  ],
  'medtech.howWeWork.step2.description1': [
    'Projektujemy rozwiązania technologiczne w pełnej zgodności z normami ISO oraz wymogami certyfikacji wyrobów medycznych (MDR i FDA).',
    'We design technological solutions in full compliance with ISO standards and medical device certification requirements (MDR and FDA).',
  ],
  'medtech.howWeWork.step2.description2': [
    'Dzięki naszemu know-how, globalne firmy z sektora medycznego oszczędzają ponad 7% swojego budżetu operacyjnego.',
    'Thanks to our know-how, global companies from the medical sector save over 7% of their operational budget.',
  ],

  'medtech.howWeWork.step3.title': [
    'Integrujemy się z urządzeniami medycznymi i systemami IoT',
    'We integrate with medical devices and IoT systems',
  ],
  'medtech.howWeWork.step3.description1': [
    'Nasze aplikacje wykorzystują zaawansowane technologie. Umożliwiamy bezproblemową integrację z urządzeniami medycznymi i systemami analizy danych w czasie rzeczywistym.',
    'Our applications use advanced technologies. We enable seamless integration with medical devices and real-time data analysis systems.',
  ],
  'medtech.howWeWork.step3.description2': [
    'Dobrze zaprojektowana architektura systemu powoduje, że projekt zyskuje ponad 9% czasu, który zwykle jest marnowany na nanoszenie poprawek.',
    'A well-designed system architecture causes the project to gain over 9% of time that is usually wasted on making corrections.',
  ],

  'medtech.howWeWork.step4.title': [
    'Zapewniamy Ci kompleksowe wsparcie',
    'We provide you with comprehensive support',
  ],
  'medtech.howWeWork.step4.description1': [
    'Bierzemy odpowiedzialność za każdy etap realizowania projektu. Dzięki nam szybciej wprowadzisz swoje innowacje na rynek i zyskasz partnera, który dostarcza rozwiązania w terminie.',
    'We take responsibility for every stage of the project implementation. Thanks to us, you will introduce your innovations to the market faster and gain a partner who delivers solutions on time.',
  ],
  'medtech.howWeWork.step4.description2': [
    'Czy wiesz, że 100% firm z którymi pracowaliśmy wyraża chęć kontynuowania rozwoju projektu z naszym zespołem?',
    'Did you know that 100% of the companies we worked with express a desire to continue developing the project with our team?',
  ],

  'medtech.nextSteps.title': [
    'Decyduję się na współpracę i co dalej?',
    "I decide to cooperate and what's next?",
  ],
  'medtech.nextSteps.step1': [
    'Rozmawiamy, słuchamy i definiujemy kluczowe cele projektu.',
    'We talk, listen, and define key project goals.',
  ],
  'medtech.nextSteps.step2': [
    'Przygotowujemy plan działania oparty na Twoich potrzebach.',
    'We prepare an action plan based on your needs.',
  ],
  'medtech.nextSteps.step3': [
    'Wdrażamy rozwiązania, które realnie wspierają Twój biznes.',
    'We implement solutions that really support your business.',
  ],

  'medtech.technologies.title': ['Technologie, które wykorzystujemy', 'Technologies we use'],

  'medtech.recognition.title': [
    'Partnerstwo na którym możesz polegać.',
    'A partnership you can rely on.',
  ],
  'medtech.recognition.subtitle1': [
    'W Appotype wierzymy, ze sukces rodzi się z silnej i opartej na zaufaniu współpracy. Chcemy być kimś więcej niż tylko dostawcą technologii. Od lat przyjmujemy pozycję strategicznego partnera, co daje nam największą satysfakcję.',
    'At Appotype, we believe that success is born from strong and trust-based cooperation. We want to be more than just a technology provider. For years, we have taken the position of a strategic partner, which gives us the greatest satisfaction.',
  ],
  'medtech.recognition.subtitle2': [
    'Nasz zespół z pasją podchodzi do każdego projektu, co ma bezpośredni wpływ na naszą proaktywną postawę. Nasi klienci mogą liczyć na otwartą komunikację na każdym etapie współpracy.',
    'Our team is passionate about every project, which has a direct impact on our proactive attitude. Our clients can count on open communication at every stage of cooperation.',
  ],

  'medtech.caseStudy.title': [
    'Przykładowe realizacje z Twojej branży',
    'Example implementations from your industry',
  ],

  'service.heroButtons.forWho': ['Dla kogo jest ta usługa?', 'Who is this service for?'],
  'service.heroButtons.specializations': ['Nasze specjalizacje', 'Our specializations'],

  // About page translations
  'about.hero.title': [
    'Poznaj zespół, który wesprze Cię w technologicznym sukcesie',
    'Meet the team that will support you in technological success',
  ],
  'about.hero.subtitle': [
    'Jesteśmy grupą ekspertów, którzy pomogą Ci zrealizować Twoje technologiczne wyzwania. Współpraca z nami to więcej niż tylko tworzenie oprogramowania. To strategiczne partnerstwo, które aktywnie wspiera rozwój Twojego biznesu.',
    "We are a group of experts who will help you realize your technological challenges. Working with us is more than just creating software. It's a strategic partnership that actively supports the development of your business.",
  ],
  'about.hero.button': ['Poznaj nasze wartości', 'Discover our values'],

  'about.values.title': ['Wartości, które nas wyróżniają', 'Values that distinguish us'],
  'about.values.subtitle': [
    'Wszystko, co robimy, opieramy na naszych wartościach.',
    'Everything we do is based on our values.',
  ],

  'about.values.card1.title': ['Koncentracja na rozwiązaniach', 'Solution-focused'],
  'about.values.card1.description1': [
    'Twoje cele biznesowe są dla nas priorytetem.',
    'Your business goals are our priority.',
  ],
  'about.values.card1.description2': [
    'Dokładnie analizujemy wyzwania i dostarczamy technologie, które przynoszą wymierne korzyści.',
    'We thoroughly analyze challenges and deliver technologies that bring measurable benefits.',
  ],

  'about.values.card2.title': ['Terminowość', 'Timeliness'],
  'about.values.card2.description1': [
    'Cenimy Twój czas. Zawsze dokładamy wszelkich starań, aby projekty były realizowane zgodnie z ustalonym harmonogramem.',
    'We value your time. We always make every effort to ensure projects are delivered according to the agreed schedule.',
  ],
  'about.values.card2.description2': ['', ''],

  'about.values.card3.title': ['Szczerość i transparentność', 'Honesty and transparency'],
  'about.values.card3.description1': [
    'Budujemy relacje na zaufaniu. Oznacza to otwartą komunikację i uczciwe przedstawianie sytuacji.',
    'We build relationships on trust. This means open communication and honest presentation of situations.',
  ],
  'about.values.card3.description2': [
    'Wierzymy, że to podstawa prawdziwego partnerstwa.',
    'We believe this is the foundation of true partnership.',
  ],

  'about.values.card4.title': [
    'Siła zespołu i stabilność firmy',
    'Team strength and company stability',
  ],
  'about.values.card4.description1': [
    'Wierzymy, że zgrany zespół to fundamenty sukcesu.',
    'We believe that a cohesive team is the foundation of success.',
  ],
  'about.values.card4.description2': [
    'Dbamy o fundamenty naszej organizacji.',
    'We take care of the foundations of our organization.',
  ],

  'about.values.card5.title': ['Ciągłe doskonalenie', 'Continuous improvement'],
  'about.values.card5.description1': [
    'Świat technologii dynamicznie ewoluuje, a my razem z nim.',
    'The world of technology is dynamically evolving, and we are evolving with it.',
  ],
  'about.values.card5.description2': [
    'Nieustannie poszerzamy wiedzę i kompetencje, aby dostarczać nowoczesne rozwiązania.',
    'We continuously expand our knowledge and competencies to deliver modern solutions.',
  ],

  'about.recognition.title': [
    'Małe sukcesy prowadzą do wielkich osiągnieć',
    'Small successes lead to great achievements',
  ],
  'about.recognition.subtitle': [
    'Te zdjęcia uwieczniają chwile, w których nasza partnerska praca została doceniona. Dla nas te nagrody to nie tylko symbole sukcesu, ale przede wszystkim potwierdzenie kierunku w jakim zmierzamy. Wierzymy, że głębokie zrozumienie potrzeb naszych klientów oraz naszego zespoły to przepis na tworzenie wyjątkowych projektów.',
    "These photos capture moments when our partnership work was appreciated. For us, these awards are not just symbols of success, but above all confirmation of the direction we are heading. We believe that a deep understanding of our clients' and our team's needs is the recipe for creating exceptional projects.",
  ],

  'about.expert.title': [
    'Zaufanie, które stało się początkiem nowej drogi',
    'Trust that became the beginning of a new path',
  ],
  'about.expert.description': [
    'Appotype nie powstało z przypadku. To klienci zauważyli w nas partnera, który rozumie wyzwania i oferuje konkretne rozwiązania.',
    'Appotype was not created by chance. It was the clients who saw in us a partner who understands challenges and offers specific solutions.',
  ],
  'about.expert.quotes1': [
    'Każda osoba w naszym zespole rozumie, jak ważne jest nie tylko oferowanie rozwiązań, ale także wsłuchiwanie się w wyzwania klientów.',
    'Each person in our team understands how important it is not only to offer solutions, but also to listen to client challenges.',
  ],
  'about.expert.quotes2': [
    'To dzięki takiemu podejściu potrafimy lepiej odpowiadać na potrzeby różnych branż i wspólnie osiągać technologiczny sukces.',
    'Thanks to this approach, we can better respond to the needs of different industries and together achieve technological success.',
  ],

  'about.strategy.title': [
    'Współpraca i Strategia: Jak tworzymy sukces?',
    'Cooperation and Strategy: How do we create success?',
  ],
  'about.strategy.subtitle': [
    'Zaczynamy od zrozumienia Twojego biznesu. Wyjaśniamy kluczowe technologie, narzędzia i metody, które mogą rozwiązać Twoje wyzwania. Mając odpowiednie zaplecze, razem dopracowujemy wizję Twojego produktu zgodnie z najnowszymi branżowymi standardami',
    'We start by understanding your business. We explain key technologies, tools and methods that can solve your challenges. With the right background, we refine the vision of your product together in accordance with the latest industry standards',
  ],
  'about.strategy.button': ['Umów się na spotkanie', 'Schedule a meeting'],

  'about.team.title': ['Poznaj ekspertów w swoich dziedzinach', 'Meet experts in their fields'],
  'about.team.subtitle': [
    'Nasz zespół to nie tylko programiści i projektanci. To eksperci, którzy w swoich dziedzinach tworzą prawdziwe innowacje.',
    'Our team is not just programmers and designers. These are experts who create real innovations in their fields.',
  ],

  'about.joinTeam.title': ['Chcesz dołączyć do naszego zespołu?', 'Want to join our team?'],
  'about.joinTeam.description': [
    'Poznaj naszą kulturę pracy oraz obszary w jakich się specjalizujemy.',
    'Learn about our work culture and the areas we specialize in.',
  ],
  'about.joinTeam.button': ['Napisz do nas!', 'Write to us!'],

  // Case Study Template translations
  'caseStudy.template.projectRole': ['Nasza rola w projekcie:', 'Our role in the project:'],
  'caseStudy.template.source': ['Źródło:', 'Source:'],
  'caseStudy.template.guarantees': ['Gwarancje', 'Guarantees'],
  'caseStudy.template.recommendations': ['Rekomendacje', 'Recommendations'],
  'caseStudy.template.education': ['Edukacja', 'Education'],
  'caseStudy.template.audit': ['Audyt', 'Audit'],
  'caseStudy.template.technologies': ['Technologie', 'Technologies'],

  // Common UI elements
  'common.readMore': ['Czytaj więcej', 'Read more'],
  'common.viewAll': ['Zobacz wszystkie', 'View all'],
  'common.learnMore': ['Dowiedz się więcej', 'Learn more'],
  'common.contactUs': ['Skontaktuj się z nami', 'Contact us'],
  'common.downloadPdf': ['Pobierz PDF', 'Download PDF'],
  'common.shareProject': ['Udostępnij projekt', 'Share project'],
  'common.nextProject': ['Następny projekt', 'Next project'],
  'common.previousProject': ['Poprzedni projekt', 'Previous project'],

  // Alt text translations
  'alt.strategy': ['Strategia', 'Strategy'],
  'alt.projectDescription': ['Opis projektu', 'Project description'],
  'alt.technologyStack': ['Stos technologiczny', 'Technology stack'],
  'alt.audit': ['Wizualizacja audytu', 'Audit visualization'],
  'alt.educationAuthor': ['Autor cytatu edukacyjnego', 'Education quote author'],

  // Team member roles
  'team.role.ceo': ['CEO', 'CEO'],
  'team.role.cfo': ['CFO', 'CFO'],
  'team.role.headOfDelivery': ['Head of Delivery', 'Head of Delivery'],
  'team.role.consultant': ['Consultant', 'Consultant'],
  'team.role.developer': ['Developer', 'Developer'],
  'team.role.ai': ['AI specialist', 'AI specialist'],
  'team.role.designer': ['Designer', 'Designer'],
  'team.role.qa': ['QA specialist', 'QA specialist'],
  'team.role.3dArtist': ['3D Artist', '3D Artist'],

  // Case studies page (realizacje)
  'caseStudies.hero.title': [
    'Wybierz historię jednego z naszych klientów',
    'Choose a story from one of our clients',
  ],
  'caseStudies.hero.subtitle': [
    'Dowiedz się, jak współpracujemy z liderami rynku, tworząc dedykowane rozwiązania technologiczne, które napędzają rozwój firm.',
    'Learn how we collaborate with market leaders, creating dedicated technological solutions that drive company growth.',
  ],
  'caseStudies.tabs.diagnozujILecz': ['Aplikacja Diagnozuj i Lecz', 'Diagnozuj i Lecz Application'],
  'caseStudies.tabs.smartMedics': ['Aplikacja SmartMedics', 'SmartMedics Application'],

  // Diagnozuj i Lecz case study
  'diagnozujILecz.title': [
    'Narzędzie wspierające diagnozowanie depresji - Diagnozuj i Lecz',
    'Tool supporting the diagnosis of depression - Diagnozuj i Lecz',
  ],
  'diagnozujILecz.subtitle': ['Wprowadzenie', 'Introduction'],
  'diagnozujILecz.projectDescription': [
    `W ramach współpracy z Angelini Pharma stworzyliśmy aplikację "Diagnozuj i Lecz" – narzędzie wspierające lekarzy oraz osoby rozpoznające wczesne objawy depresji. Głównym celem projektu jest zwiększenie świadomości w obszarze zdrowia psychicznego.`,
    `As part of our cooperation with Angelini Pharma, we created the "Diagnozuj i Lecz" application - a tool supporting doctors and people recognizing early symptoms of depression. The main goal of the project is to increase awareness in the area of mental health.`,
  ],
  'diagnozujILecz.task1': [
    'Zbudowaliśmy architekturę aplikacji',
    'We built the application architecture',
  ],
  'diagnozujILecz.task2': [
    'Zaprojektowaliśmy intuicyjny interfejs',
    'We designed an intuitive interface',
  ],
  'diagnozujILecz.task3': [
    'Integrowaliśmy aplikację z zewnętrznymi systemami',
    'We integrated the application with external systems',
  ],
  'diagnozujILecz.task4': [
    'Zadbaliśmy o wysoką skalowalność i multiplatformowość',
    'We ensured high scalability and multi-platform capability',
  ],
  'diagnozujILecz.introImageSource': [
    'Aplikacja Diagnozuj i Lecz dostępna w AppStore oraz Google Play',
    'Diagnozuj i Lecz application available in AppStore and Google Play',
  ],
  'diagnozujILecz.description.title': ['Wprowadzenie', 'Introduction'],
  'diagnozujILecz.description.text1': [
    'Stanęliśmy przed zadaniem stworzenia aplikacji, która łączy wysokiej jakości treści edukacyjne z intuicyjną i płynną obsługą.',
    'We faced the task of creating an application that combines high-quality educational content with intuitive and smooth operation.',
  ],
  'diagnozujILecz.description.text2': [
    'Największym wyzwaniem projektowym było gruntowne zrozumienie problemu oraz sposobu działania aplikacji.',
    'The biggest design challenge was to thoroughly understand the problem and how the application works.',
  ],
  'diagnozujILecz.description.text3': [
    'Firma Angelini Pharma opracowała kluczowe założenia. Następnym krokiem było zaprojektowanie i wdrożenie tych założeń do działającej aplikacji.',
    'Angelini Pharma developed key assumptions. The next step was to design and implement these assumptions into a working application.',
  ],
  'diagnozujILecz.description.imageSource': [
    'Aplikacja Diagnozuj i Lecz dostępna w AppStore oraz Google Play',
    'Diagnozuj i Lecz application available in AppStore and Google Play',
  ],
  'diagnozujILecz.technology.title': [
    'Rozbudowane formularze i algorytmy diagnostyczne',
    'Extensive forms and diagnostic algorithms',
  ],
  'diagnozujILecz.technology.text1': [
    'Otrzymaliśmy dużo informacji diagnostycznych. Spotkania z ekspertami z psychiatrii pomagały nam systematyzować wiedzę. Taki fundament merytoryczny spowodował, że opracowaliśmy narzędzie wspierające diagnozowanie depresji zgodnie z międzynarodowymi standardami diagnostyki depresji.',
    'We received a lot of diagnostic information. Meetings with psychiatry experts helped us systematize knowledge. Such a substantive foundation made us develop a tool supporting the diagnosis of depression in accordance with international standards of depression diagnostics.',
  ],
  'diagnozujILecz.technology.text2': [
    'Aplikacja prowadzi użytkowników przez zestaw pytań. Następnie generuje szczegółowe wyniki, oferując wsparcie teoretyczne. Ponadto użytkownicy mogą wykonywać ćwiczenia diagnostyczne, czy sprawdzać tabele leków. Aplikacja jest niesamowitym połączeniem wiedzy teoretycznej z wiedzą praktyczną.',
    'The application guides users through a set of questions. It then generates detailed results, offering theoretical support. In addition, users can perform diagnostic exercises or check drug tables. The application is an amazing combination of theoretical knowledge and practical knowledge.',
  ],
  'diagnozujILecz.technology.imageSource': [
    'Aplikacja Diagnozuj i Lecz dostępna w AppStore oraz Google Play',
    'Diagnozuj i Lecz application available in AppStore and Google Play',
  ],
  'diagnozujILecz.expert.title': ['Naszym zdaniem...', 'In our opinion...'],
  'diagnozujILecz.expert.description': [
    'To był sztandarowy projekt w którym nie jest istotna tylko wiedza techniczna, ale również świadomość działania branży medycznej.',
    "It was a flagship project in which not only technical knowledge is important, but also awareness of the medical industry's operation.",
  ],
  'diagnozujILecz.expert.quote': [
    `Aplikacja "Diagnozuj i Lecz" zmienia życie. Mamy realny wpływ na poprawę jakości życia dzięki nowoczesnemu podejściu do edukacji. Współpraca z Angelini Pharma spowodowała, że Appotype również zostawił swój ślad.`,
    `The "Diagnozuj i Lecz" application changes lives. We have a real impact on improving the quality of life thanks to a modern approach to education. Cooperation with Angelini Pharma caused Appotype to also leave its mark.`,
  ],
  'diagnozujILecz.guarantees.title': [
    'Technologiczny fundament dla rozwoju aplikacji Diagnozuj i lecz',
    'Technological foundation for the development of the Diagnozuj i Lecz application',
  ],
  'diagnozujILecz.guarantees.description': [
    'Oto kluczowe obszary, na których się skupiliśmy:',
    'Here are the key areas we focused on:',
  ],
  'diagnozujILecz.guarantees.item1.title': [
    'Stabilność i płynność działania',
    'Stability and smooth operation',
  ],
  'diagnozujILecz.guarantees.item1.description': [
    'Tak zaprojektowaliśmy aplikację, aby zapewnić jej płynność działania w każdej sytuacji. Niezależnie od liczby użytkowników.',
    'We designed the application to ensure its smooth operation in any situation. Regardless of the number of users.',
  ],
  'diagnozujILecz.guarantees.item2.title': [
    'Bezpieczeństwo danych medycznych',
    'Security of medical data',
  ],
  'diagnozujILecz.guarantees.item2.description': [
    'SmartMedics spełnia najwyższe standardy bezpieczeństwa, zgodne z HIPAA i RODO. Dane użytkowników są szyfrowane i bezpiecznie przechowywane.',
    'SmartMedics meets the highest security standards, compliant with HIPAA and GDPR. User data is encrypted and securely stored.',
  ],
  'diagnozujILecz.guarantees.item3.title': ['Skalowalność rozwiązań', 'Scalability of solutions'],
  'diagnozujILecz.guarantees.item3.description': [
    'Zaprojektowaliśmy system tak, aby umożliwić jego ciągły rozwój. Aplikacja Diagnozuj i Lecz może rosnąć wraz z potrzebami firmy. W ten sposób jest przygotowana na przyszłe wyzwania i nowe funkcjonalności.',
    "We designed the system to enable its continuous development. The Diagnozuj i Lecz application can grow with the company's needs. In this way, it is prepared for future challenges and new functionalities.",
  ],
  'diagnozujILecz.recommendations.title': [
    'Z perspektywy Angelini Pharma',
    "From Angelini Pharma's perspective",
  ],
  'diagnozujILecz.recommendations.description': ['', ''],
  'diagnozujILecz.recommendations.quote1': [
    'Szukaliśmy partnera, który nie tylko zapewni nam odpowiednie rozwiązania technologiczne, ale także pomoże zrozumieć potencjalne wyzwania. Ostatecznie udało się. Appotype skutecznie połączyło zaawansowaną wiedzę technologiczną ze zrozumieniem specyfiki naszej branży.',
    'We were looking for a partner who would not only provide us with appropriate technological solutions, but also help us understand potential challenges. Eventually, it worked out. Appotype effectively combined advanced technological knowledge with understanding the specifics of our industry.',
  ],
  'diagnozujILecz.education.title': ['Strefa edukacyjna', 'Educational zone'],
  'diagnozujILecz.education.description': [
    'Jakie wnioski możemy wyciągnąć na podstawie tego projektu?',
    'What conclusions can we draw from this project?',
  ],
  'diagnozujILecz.education.quote': [
    'Zdecydowaliśmy się napisać aplikację w technologii Flutter. Dzięki temu stworzyliśmy jeden produkt, a użytkownicy korzystają z aplikacji na platformie Android, iOS oraz na komputerze.',
    'We decided to write the application in Flutter technology. Thanks to this, we created one product, and users use the application on Android, iOS and computer platforms.',
  ],
  'diagnozujILecz.audit.title': [
    'Współpraca z zaufanym partnerem jest niezwykle istotna',
    'Cooperation with a trusted partner is extremely important',
  ],
  'diagnozujILecz.audit.description': [
    'W Appotype wierzymy, że zaufanie to podstawa udanej współpracy. Naszym celem jest nie tylko dostarczenie rozwiązań, ale również zapewnienie klientom poczucia, że ich projekty są w dobrych rękach.',
    'At Appotype, we believe that trust is the foundation of successful cooperation. Our goal is not only to deliver solutions, but also to ensure clients feel that their projects are in good hands.',
  ],
  'diagnozujILecz.audit.additionalDescription': [
    `Jesteśmy przekonani, że przejrzysta komunikacja i niezawodne wsparcie techniczne to fundamenty każdej współpracy. Projekt "Diagnozuj i Lecz" udowadnia, że rzetelność i profesjonalizm owocują trwałymi relacjami oraz sukcesem naszych klientów.`,
    `We are convinced that transparent communication and reliable technical support are the foundations of any cooperation. The "Diagnozuj i Lecz" project proves that reliability and professionalism result in lasting relationships and the success of our clients.`,
  ],

  // SmartMedics case study
  'smartMedics.title': ['Aplikacja SmartMedics', 'SmartMedics Application'],
  'smartMedics.subtitle': ['Wprowadzenie', 'Introduction'],
  'smartMedics.projectDescription': [
    `SmartMedics to innowacyjna aplikacja medyczna. Integruje się z urządzeniami EKG wspierając lekarzy w diagnostyce i monitorowaniu pacjentów w czasie rzeczywistym.`,
    `SmartMedics is an innovative medical application. It integrates with ECG devices supporting doctors in diagnosing and monitoring patients in real time.`,
  ],
  'smartMedics.task1': [
    'Usunięcie licznych błędów technicznych',
    'Removing numerous technical errors',
  ],
  'smartMedics.task2': [
    'Przepisanie i rozbudowa funkcjonalności aplikacji',
    'Rewriting and expanding application functionality',
  ],
  'smartMedics.task3': ['Integracja z urządzeniami EKG', 'Integration with ECG devices'],
  'smartMedics.task4': [
    'Zgodność z normami dla wyrobów medycznych',
    'Compliance with standards for medical devices',
  ],
  'smartMedics.introImageSource': ['Aplikacja SmartMedics', 'SmartMedics Application'],
  'smartMedics.description.title': ['Wprowadzenie', 'Introduction'],
  'smartMedics.description.text1': [
    'Celem aplikacji jest unowocześnienie opieki medycznej. System gromadzi i analizuje dane pacjentów w czasie rzeczywistym.',
    'The goal of the application is to modernize medical care. The system collects and analyzes patient data in real time.',
  ],
  'smartMedics.description.text2': [
    'Marka SmartMedics napotkała poważne problemy techniczne już na wczesnym etapie rozwoju. Aplikacja często się zawieszała i nadmiernie zużywała zasoby systemowe.',
    'The SmartMedics brand encountered serious technical problems early in development. The application often froze and excessively consumed system resources.',
  ],
  'smartMedics.description.text3': [
    'Aplikacja powinna działać bezawaryjnie. Ponadto gromadzone dane medyczne wymagały od SmartMedics spełniania najwyższych standardów bezpieczeństwa.',
    'The application should work flawlessly. In addition, the collected medical data required SmartMedics to meet the highest security standards.',
  ],
  'smartMedics.description.imageSource': [
    'Grafika pochodzi z systemu SmartMedics Firmy Smartmedics sp. z o.o.',
    'The graphic comes from the SmartMedics system of Smartmedics sp. z o.o.',
  ],
  'smartMedics.technology.title': [
    `Pebble – niepozorne, ale wyjątkowo potężne urządzenie`,
    `Pebble - inconspicuous but extremely powerful device`,
  ],
  'smartMedics.technology.text1': [
    `Pebble komunikuje się z aplikacją mobilną za pomocą technologii Bluetooth Low Energy (BLE). To właśnie małe urządzenie dostarcza bardzo ważne dane, które powinny być odpowiednio zinterpretowane przez system.`,
    `Pebble communicates with the mobile application using Bluetooth Low Energy (BLE) technology. It is this small device that provides very important data that should be properly interpreted by the system.`,
  ],
  'smartMedics.technology.text2': [
    `Naszym wyzwaniem było zapewnienie płynnej transmisji danych w czasie rzeczywistym. Dlaczego uznajemy to za wyzwanie? Jednym z głównych ograniczeń technicznych jest niska przepustowość łącza. To powoduje, że przesyłania danych w tej technologi wymaga kreatywnego podejścia w projektowaniu architektury.`,
    `Our challenge was to ensure smooth data transmission in real time. Why do we consider this a challenge? One of the main technical limitations is the low bandwidth. This means that data transmission in this technology requires a creative approach to architecture design.`,
  ],
  'smartMedics.technology.imageSource': [
    'Materiały własne SmartMedics',
    'SmartMedics own materials',
  ],
  'smartMedics.expert.title': [
    'Oczami eksperta Appotype',
    'Through the eyes of an Appotype expert',
  ],
  'smartMedics.expert.description': [
    `SmartMedics ewoluował w pełnoprawny system, obejmujący aplikację mobilną, webową oraz integrację z zaawansowanymi urządzeniami medycznymi.`,
    `SmartMedics evolved into a full-fledged system, including a mobile application, web application and integration with advanced medical devices.`,
  ],
  'smartMedics.expert.quote1': [
    `Bezpieczeństwo danych medycznych i niezawodność komunikacji to kluczowe aspekty, które uwzględniliśmy w projekcie SmartMedics.`,
    `Medical data security and communication reliability are key aspects that we considered in the SmartMedics project.`,
  ],
  'smartMedics.expert.quote2': [
    `Integracja z urządzeniami EKG wymagała szczególnej uwagi ze względu na krytyczny charakter przesyłanych danych.`,
    `Integration with ECG devices required special attention due to the critical nature of the transmitted data.`,
  ],
  'smartMedics.expert.quote3': [
    `Nasze doświadczenie w projektach medycznych pozwoliło nam skutecznie zoptymalizować system i zapewnić jego niezawodne działanie.`,
    `Our experience in medical projects allowed us to effectively optimize the system and ensure its reliable operation.`,
  ],
  'smartMedics.guarantees.title': [
    'Technologiczny fundament dla rozwoju aplikacji SmartMedics',
    'Technological foundation for the development of the SmartMedics application',
  ],
  'smartMedics.guarantees.description': [
    'W przypadku projektu SmartMedics skupiliśmy się na stworzeniu aplikacji, która nie tylko działa, ale także spełnia wymagania branży medycznej. Oto kluczowe obszary, na których się skupiliśmy:',
    'In the case of the SmartMedics project, we focused on creating an application that not only works, but also meets the requirements of the medical industry. Here are the key areas we focused on:',
  ],
  'smartMedics.guarantees.item1.title': [
    'Stabilność i płynność działania',
    'Stability and smooth operation',
  ],
  'smartMedics.guarantees.item1.description': [
    'Przebudowaliśmy aplikację od podstaw, eliminując problemy techniczne. Zapewniliśmy płynność działania na różnych platformach.',
    'We rebuilt the application from scratch, eliminating technical problems. We ensured smooth operation on various platforms.',
  ],
  'smartMedics.guarantees.item2.title': ['Chmurowa Infrastruktura', 'Cloud Infrastructure'],
  'smartMedics.guarantees.item2.description': [
    'Dzięki integracji z chmurą, system SmartMedics wspiera również zdalną diagnostykę. Lekarze mają dostęp do danych pacjentów z dowolnego miejsca na świecie.',
    'Thanks to cloud integration, the SmartMedics system also supports remote diagnostics. Doctors have access to patient data from anywhere in the world.',
  ],
  'smartMedics.guarantees.item3.title': ['Skalowalność rozwiązań', 'Scalability of solutions'],
  'smartMedics.guarantees.item3.description': [
    'Zaprojektowaliśmy system tak, aby umożliwić jego ciągły rozwój. Aplikacja SmartMedics może rosnąć wraz z potrzebami firmy. W ten sposób jest przygotowana na przyszłe wyzwania i nowe funkcjonalności.',
    "We designed the system to enable its continuous development. The SmartMedics application can grow with the company's needs. In this way, it is prepared for future challenges and new functionalities.",
  ],
  'smartMedics.guarantees.item4.title': [
    'Bezpieczeństwo danych medycznych',
    'Security of medical data',
  ],
  'smartMedics.guarantees.item4.description': [
    'SmartMedics spełnia najwyższe standardy bezpieczeństwa, zgodne z HIPAA i RODO. Dane pacjentów są szyfrowane i monitorowane.',
    'SmartMedics meets the highest security standards, compliant with HIPAA and GDPR. Patient data is encrypted and monitored.',
  ],
  'smartMedics.guarantees.item5.title': [
    'Zgodność z przepisami i normami branżowymi',
    'Compliance with industry regulations and standards',
  ],
  'smartMedics.guarantees.item5.description': [
    'System spełnia wymogi prawne dla wyrobów medycznych. Ponadto posiada certyfikacje i jest regularnie audytowany.',
    'The system meets legal requirements for medical devices. In addition, it is certified and regularly audited.',
  ],
  'smartMedics.guarantees.item6.title': [
    'Działanie przy niskiej przepustowości sieci',
    'Operation at low network bandwidth',
  ],
  'smartMedics.guarantees.item6.description': [
    'Aplikacja działa niezawodnie nawet przy słabym internecie, zapewniając ciągłą transmisję danych EKG.',
    'The application works reliably even with poor internet, ensuring continuous transmission of ECG data.',
  ],
  'smartMedics.recommendations.title': [
    'Kluczowe zmiany, które otwierają nowe możliwości',
    'Key changes that open new possibilities',
  ],
  'smartMedics.recommendations.description': [
    'Współpraca z Appotype pozwoliła na wprowadzenie istotnych zmian w projekcie SmartMedics, które otworzyły przed firmą nowe perspektywy rozwoju.',
    'Cooperation with Appotype allowed for the introduction of significant changes to the SmartMedics project, which opened new development perspectives for the company.',
  ],
  'smartMedics.recommendations.quote1': [
    `Na początku ostrożnie obieraliśmy kierunek rozwoju, ale już pierwsze zmiany wprowadzone przez Appotype wyraźnie poprawiły stabilność systemu. Ich działania upewniły nas, że pracujemy z partnerem godnym zaufania.`,
    `At the beginning, we carefully chose the direction of development, but the first changes introduced by Appotype significantly improved the stability of the system. Their actions assured us that we are working with a trustworthy partner.`,
  ],
  'smartMedics.recommendations.quote2': [
    `To właśnie dlatego współpracujemy z Appotype do dzisiaj, stale udoskonalając nasze rozwiązania.`,
    `That is why we continue to work with Appotype today, constantly improving our solutions.`,
  ],
  'smartMedics.education.title': ['Strefa edukacyjna', 'Educational zone'],
  'smartMedics.education.description': [
    'Nasz profesjonalizm, to suma różnych doświadczeń projektowych. Jakie wnioski możemy wyciągnąć na podstawie tego projektu?',
    'Our professionalism is the sum of various project experiences. What conclusions can we draw from this project?',
  ],
  'smartMedics.education.quote': [
    `Zaniedbanie aktualizacji i rozwoju kodu prowadzi do narastającego długu technologicznego. W krytycznych momentach okazuje się, że bardziej opłacalne jest napisanie nowej aplikacji, niż robić refactor starego kodu.`,
    `Neglecting code updates and development leads to growing technical debt. At critical moments, it turns out that it is more cost-effective to write a new application than to refactor old code.`,
  ],
  'smartMedics.audit.title': [
    'Współpraca z zaufanym partnerem jest niezwykle istotna',
    'Cooperation with a trusted partner is extremely important',
  ],
  'smartMedics.audit.description': [
    'Zaufanie budujemy na przejrzystej komunikacji i rzetelnym wsparciu technicznym. Zawsze jesteśmy gotowi wspólnie rozwiązywać wyzwania.',
    'We build trust on transparent communication and reliable technical support. We are always ready to solve challenges together.',
  ],
  'smartMedics.audit.additionalDescription': [
    `Przykład SmartMedics pokazuje, że długoterminowa współpraca oparta na zaufaniu przynosi efekty. Od pierwszych etapów naprawy aplikacji aż po jej rozbudowę o nowe funkcje. Wspólnie dążymy do jednego celu: dostarczenia możliwie najlepszego produktu.`,
    `The SmartMedics example shows that long-term cooperation based on trust brings results. From the first stages of repairing the application to expanding it with new functions. Together we strive for one goal: to deliver the best possible product.`,
  ],

  // Service page common elements
  'service.cta.expertTask': [
    'Nie musisz być ekspertem - to nasze zadanie!',
    "You don't need to be an expert - that's our job!",
  ],
  'service.cta.expertSubtitle': [
    'W dynamicznym świecie cyfryzacji liczy się każdy detal. Bez względu na to, na jakim etapie transformacji cyfrowej jesteś. Nasi eksperci pomogą Ci znaleźć i wdrożyć odpowiednie rozwiązania.',
    "In the dynamic world of digitalization, every detail matters. Regardless of what stage of digital transformation you're at. Our experts will help you find and implement the right solutions.",
  ],
  'service.nextSteps.title': [
    'Decyduję się na współpracę i co dalej?',
    "I decide to cooperate and what's next?",
  ],
  'service.enterprise.title': [
    'Dlaczego warto skorzystać z nowej usługi na rynku?',
    'Why is it worth using a new service on the market?',
  ],
  'service.enterprise.subtitle': [
    'Nasze doradztwo przekształca złożone wyzwania technologiczne w konkretne wyniki. Pomożemy Ci optymalizować procesy i znacząco zredukować koszty.',
    'Our consulting transforms complex technological challenges into concrete results. We will help you optimize processes and significantly reduce costs.',
  ],

  // SoftwareAgencyPage specific translations
  'softwareAgency.hero.title': [
    'Budujemy oprogramowanie, które napędza Twoją wizję',
    'We build software that drives your vision',
  ],
  'softwareAgency.hero.subtitle': [
    'Odkryj narzędzia, które pomogą Ci zbudować przewagę nad konkurencją. Niezależnie w jakiej branży rozwijasz swoją firmę, dostosujemy aplikację do Twoich potrzeb.',
    "Discover tools that will help you build a competitive advantage. Regardless of what industry you're developing your company in, we will adapt the application to your needs.",
  ],
  'softwareAgency.industry.title': [
    'Szukasz partnera technologicznego, który...',
    'You are looking for a technology partner who...',
  ],
  'softwareAgency.industry.card1': [
    'Zrealizuje projekt zgodnie z Twoją wizją.',
    'Will implement the project according to your vision.',
  ],
  'softwareAgency.industry.card2': [
    'Weźmie odpowiedzialność za wdrożenie produktu z gwarancją ustalonej ceny.',
    'Will take responsibility for launching the product with a guaranteed fixed price.',
  ],
  'softwareAgency.industry.card3': [
    'Zintegruje różne urządzenia i środowiska pracy',
    'Will integrate different devices and work environments',
  ],
  'softwareAgency.howWeWork.title': [
    'Twoje projekty są w rękach profesjonalistów',
    'Your projects are in the hands of professionals',
  ],

  // EnterprisePage specific translations
  'enterprise.hero.title': [
    'Technologiczne wsparcie dla Twojego biznesu',
    'Technological support for your business',
  ],
  'enterprise.hero.subtitle': [
    'Zapewniamy kompleksowe doradztwo i ekspercki nadzór. Dopilnujemy, aby Twoje kluczowe projekty IT osiągały strategiczne cele, były bezpieczne i prowadzone zgodnie z harmonogramem.',
    'We provide comprehensive consulting and expert supervision. We will ensure that your key IT projects achieve strategic goals, are secure and carried out according to schedule.',
  ],
  'enterprise.industry.title': [
    'Zarządzasz ogromnym budżetem, dlatego...',
    'You manage a huge budget, so...',
  ],
  'enterprise.howWeWork.title': [
    'Zaufaj naszym ekspertom w kluczowych obszarach IT',
    'Trust our experts in key IT areas',
  ],

  // AIPage specific translations
  'ai.hero.title': [
    'Wdrażamy sztuczną inteligencję, która rozwija Twój biznes',
    'We implement artificial intelligence that drives your business',
  ],
  'ai.hero.subtitle': [
    'Sztuczna inteligencja to przyszłość, którą możesz wdrożyć już dziś. Razem zbudujemy innowacyjne rozwiązania, które wyznaczą nowe standardy w Twojej branży.',
    'Artificial intelligence is the future, which you can implement today. Together, we will build innovative solutions that will set new standards in your industry.',
  ],
  'ai.industry.title': [
    'Transformacja oparta o sztuczną inteligencję...',
    'Artificial intelligence-based transformation...',
  ],
  'ai.industry.card1': [
    'Automatyzuje powtarzalne procesy biznesowe',
    'Automates repetitive business processes',
  ],
  'ai.industry.card2': [
    'Dostarcza precyzyjne analizy danych i predykcje',
    'Provides precise data analysis and predictions',
  ],
  'ai.industry.card3': [
    'Zwiększa wydajność operacyjną i redukuje koszty',
    'Increases operational efficiency and reduces costs',
  ],
  'ai.howWeWork.title': [
    'Innowacje wspierane wiedzą i doświadczeniem',
    'Innovations supported by knowledge and experience',
  ],

  'ai.howWeWork.step1.title': ['Tworzymy dedykowane modele AI', 'We create custom AI models'],
  'ai.howWeWork.step1.description1': [
    'Możesz mieć własny model sztucznej intelifencji, który jest dostosowany do potrzeb Twojego biznesu. Za jego pomocą możesz skutecznie zarządzać danymi i wyciągać z nich wartościowe wnioski.',
    'You can have your own AI model, which is tailored to your business needs. With its help, you can effectively manage data and draw valuable conclusions from it.',
  ],
  'ai.howWeWork.step1.description2': [
    'Startupy medyczne wykorzystują modele AI do analizy wyników pacjentów, co przyspiesza diagnostykę o 25%.',
    'Medical startups use AI models to analyze patient results, which accelerates diagnosis by 25%.',
  ],

  'ai.howWeWork.step2.title': [
    'Pracujemy na dużych modelach językowych',
    'We work on large language models',
  ],
  'ai.howWeWork.step2.description1': [
    'Wykorzystaj zaawansowane możliwości dużych modeli językowych (LLM). Przeprowadź transformację komunikacji i automatyzacji zadań w Twojej firmie. Oferujemy rozwiązania, które usprawniają analizę tekstu, generują treści i tworzą inteligentne rozwiązania.',
    'Use the advanced capabilities of large language models (LLM). Conduct a transformation of communication and automation of tasks in your company. We offer solutions that improve text analysis, generate content and create intelligent solutions.',
  ],
  'ai.howWeWork.step2.description2': [
    'Dla globalnych zespołów duże modele językowe skracają czas reakcji o 60%, automatyzując większość zapytań do biura obsługi klienta.',
    'For global teams, large language models reduce response times by 60%, automating most customer service queries.',
  ],

  'ai.howWeWork.step3.title': [
    'Data Science, czyli zaawansowana praca z danymi',
    'Data Science, the advanced work with data',
  ],
  'ai.howWeWork.step3.description1': [
    'Przekształć surowe dane w cenne informacje dzięki naszym zaawansowanym usługom Data Science. Tworzymy modele analityczne, które identyfikują wzorce, przewidują trendy i wspierają podejmowanie lepszych decyzji biznesowych.',
    'Transform raw data into valuable information thanks to our advanced Data Science services. We create analytical models that identify patterns, predict trends and support better business decisions.',
  ],
  'ai.howWeWork.step3.description2': [
    'W firmach logistycznych AI może zredukować liczbę błędów nawet o 40%.',
    'In logistics companies, AI can reduce the number of errors by up to 40%.',
  ],

  'ai.recognition.title': [
    'Partnerstwo, które napędza innowacje AI',
    'A partnership that drives AI innovations',
  ],
  'ai.recognition.subtitle1': [
    'W Appotype wierzymy, ze sukces rodzi się z silnej i opartej na zaufaniu współpracy. Chcemy być kimś więcej niż tylko dostawcą technologii AI. Od lat przyjmujemy pozycję strategicznego partnera, co jest dla nas szczególnie ważne w obliczu niesamowitego przyspieszenia cyfrowej transformacji.',
    'We believe that success is born from a strong and trust-based partnership. We want to be more than just a provider of AI technology. For years, we have taken the position of a strategic partner, which is particularly important in the face of unprecedented digital transformation.',
  ],
  'ai.recognition.subtitle2': [
    'Nasz zespół testuje najnowsze modele językowe oraz inne innowacje AI, aby dostarczyć Twojej firmie gotowe i sprawdzone know-how. Jesteśmy przekonani, że dobrze zoptymalizowane zaplecze technologiczne zapewni Ci znaczącą przewagę konkurencyjną.',
    'Our team tests the latest language models and other AI innovations to deliver ready-made and proven know-how to your company. We are convinced that well-optimized technological infrastructure will give you a significant competitive advantage.',
  ],

  // Contact FAQ
  'contact.faq.question1': [
    'W jakim modelu rozliczeniowym pracujecie?',
    'In what billing model do you work?',
  ],
  'contact.faq.answer1': [
    'Zwykle pracujemy w modelu Fixed Price, w którym z góry ustalamy zakres i cenę projektu. Ten model pozwoli Ci precyzyjnie zarządzać budżetem. Z sukcesem zrealizowaliśmy już kilkanaście projektów w obu formach rozliczeń, co gwarantuje wysoką jakość naszych usług. Jesteśmy otwarci na różne formy współpracy, dlatego alternatywnie oferujemy model Time and Material, gdzie rozliczamy się za poszczególne etapy prac',
    'We usually work in the Fixed Price model, where we pre-set the scope and price of the project. This model allows you to precisely manage your budget. We have successfully completed several projects in both billing models, which guarantees the high quality of our services. We are open to different forms of cooperation, so alternatively we offer the Time and Material model, where we bill for individual project stages.',
  ],
  'contact.faq.question2': [
    'Czy realizujecie projekty kompleksowo?',
    'Do you implement projects comprehensively?',
  ],
  'contact.faq.answer2': [
    'To zależy od Twoich potrzeb. Możemy wziać odpowiedzialność za cały projekt lub jego część.',
    'It depends on your needs. We can take responsibility for the entire project or its part.',
  ],
  'contact.faq.question3': [
    'Czy oferujecie body leasing specjalistów?',
    'Do you offer body leasing specialists?',
  ],
  'contact.faq.answer3': [
    'Tak, jako firma doradcza, możemy udostępnić nasz doświadczony zespół do realizacji Twojego projektu. Jeżeli nasze zasoby są w pełni zaangażowane, pomożemy Ci w zbudowaniu zespołu o dokładnie takich kompetencjach, jakich potrzebujesz.',
    'Yes, as a consulting company, we can provide our experienced team to implement your project. If our resources are fully engaged, we can help you build a team with exactly the skills you need.',
  ],
  'contact.faq.question4': [
    'Ile kosztuje stworzenie MVP (Minimum Value Products)?',
    'How much does it cost to create an MVP (Minimum Value Product)?',
  ],
  'contact.faq.answer4': [
    'Koszt stworzenia MVP zależy często od zdefiniowanego zakresu funkcjonalności. Bazując na naszym doświadczeniu, projekty MVP zwykle mieszczą się w budżecie od 60 000 do 100 000 złotych (od 14 000 do 24 000 euro). Realizacja zwykle zajmuje około 2 miesiące. Pamiętaj jednak, że jest to wartość uśredniona. Skontaktuj się z nami, abyśmy mogli dokładnie przeanalizować Twój produkt.',
    'The cost of creating an MVP depends on the defined scope of functionality. Based on our experience, MVP projects usually fit into a budget of 60,000 to 100,000 zł (14,000 to 24,000 euros). The implementation usually takes about 2 months. Remember, however, that this is an averaged value. Contact us to analyze your product in detail.',
  ],
  'contact.faq.question5': [
    'Czy oferujecie wsparcie powdrożeniowe?',
    'Do you offer post-implementation support?',
  ],
  'contact.faq.answer5': [
    'Oczywiście! Opracowaliśmy trzy różne pakiety wsparcia powdrożeniowego. Możesz wybrać ten, który najbardziej pasuje do Twoich potrzeb. Skontaktuj się (link), żeby dowiedzieć się więcej.', // TODO: add link
    'Absolutely! We have developed three different packages of post-implementation support. You can choose the one that best suits your needs. Contact us (link) to learn more.', // TODO: add link
  ],
  'contact.faq.question6': [
    'Mamy produkt, który był rozwijany przez inny software house. Czy możecie pomóc go naprawić lub dalej rozwijać?',
    'We have a product that was developed by another software house. Can you help fix it or develop it further?',
  ],
  'contact.faq.answer6': [
    'Oczywiście, mamy doświadczenie w przejmowaniu projektów realizowanych przez inne firmy. Wielokrotnie rozwijaliśmy istniejące aplikacje oraz systemy, także możesz liczyć na nasze wsparcie.',
    'Of course, we have experience in taking over projects developed by other companies. We have developed many existing applications and systems, so you can count on our support.',
  ],
  'contact.faq.question7': [
    'Czy i w jakim zakresie pomagacie w procesie rejestracji urządzeń medycznych?',
    'Do you and in what scope help with the process of registering medical devices?',
  ],
  'contact.faq.answer7': [
    'Nasze wsparcie koncentruje się na zapewnieniu zgodności oprogramowania wyrobów medycznych z międzynarodową normą IEC 62304. Norma ta określa wymagania dotyczące cyklu życia oprogramowania medycznego i jest kluczowa dla procesu rejestracji urządzeń zawierających oprogramowanie.',
    'Our support focuses on ensuring the compliance of medical device software with the international standard IEC 62304. This standard defines the requirements for the lifecycle of medical device software and is crucial for the process of registering devices containing software.',
  ],
  'contact.faq.question8': [
    'Co obejmuje nasze wsparcie w ramach normy IEC 62304:',
    'What does our support in the IEC 62304 standard include:',
  ],
  'contact.faq.answer8': [
    `- Realizację projektów oprogramowania medycznego zgodnie ze wszystkimi procesami cyklu życia oprogramowania wymaganymi przez normę IEC 62304, obejmując etapy od planowania, przez analizę, projektowanie, implementację i testowanie, aż po wydanie oraz utrzymanie oprogramowania.

    - Tworzenie i zarządzanie dokumentacją oprogramowania wymaganą przez normę IEC 62304, która stanowi istotną część ogólnej dokumentacji technicznej wyrobu medycznego (np. na potrzeby MDR lub FDA).

    - Przeprowadzanie "gap analysis" (analizy luk) istniejącej dokumentacji oraz procesów rozwoju oprogramowania pod kątem ich zgodności z wymaganiami normy IEC 62304.`,
    `- Realizing medical software projects in accordance with all software lifecycle processes required by the IEC 62304 standard, including planning, analysis, design, implementation, testing, release, and maintenance of software.

    - Creating and managing software documentation required by the IEC 62304 standard, which is an essential part of the overall technical documentation of the medical device (e.g., for MDR or FDA purposes).

    - Conducting "gap analysis" (analysis of gaps) of existing documentation and software development processes in terms of their compliance with the requirements of the IEC 62304 standard.`,
  ],
  'contact.faq.question9': [
    'Czy pracujecie z klientami spoza Unii Europejskiej?',
    'Do you work with clients outside the European Union?',
  ],
  'contact.faq.answer9': [
    'Tak, współpracujemy z klientami z różnych części świata. Realizowaliśmy projekty m.in dla partnerów z Wielkiej Brytanii oraz Zjednoczonych Emiratów Arabskich. Jesteśmy otwarci na nowe wyzwania i gotowi do współpracy z firmami z każdego zakątka świata.',
    'Yes, we cooperate with clients from different parts of the world. We have implemented projects for partners from the UK and the United Arab Emirates. We are open to new challenges and ready to cooperate with companies from every corner of the world.',
  ],
  'contact.faq.question10': [
    'Czy realizujecie wyłącznie projekty z sektora ochrony zdrowia (medtech)?',
    'Do you only implement projects in the healthcare sector (medtech)?',
  ],
  'contact.faq.answer10': [
    'Specjalizujemy się w innowacyjnych projektach z obszaru medtech i health, ponieważ wierzymy w technologię, która realnie poprawia jakość życia. Jednak nasze kompetencje i doświadczenie pozwalają nam z sukcesem realizować również projekty z innych branż, takich jak Business Intelligence, IoT (Internet Rzeczy), Utility (sektor użyteczności publicznej) czy Entertainment.',
    'We specialize in innovative projects in the medtech and health sector, as we believe in technology that truly improves quality of life. However, our expertise and experience allow us to successfully implement projects in other industries, such as Business Intelligence, IoT (Internet of Things), Utility (public utility sector), and Entertainment.',
  ],
  'contact.faq.question11': [
    'Czy przenosicie prawa autorskie do produktu?',
    'Do you transfer copyright to the product?',
  ],
  'contact.faq.answer11': [
    `Tak, przenosimy majątkowe prawa autorskie do stworzonego oprogramowania w najszerszym zakresie dopuszczalnym przez prawo. W sytuacjach, gdy pełne przeniesienie praw nie jest możliwe, udzielamy niewyłącznej, nieograniczonej czasowo i terytorialnie licencji na korzystanie z naszych utworów.

Wielokrotnie pomagaliśmy klientom, którzy doświadczyli problemu „vendor lock-in" (uzależnienia od jednego dostawcy). Dzięki naszej polityce masz pewność, że niezależnie od skali projektu, zachowujesz pełną kontrolę nad swoim produktem.`,
    `Yes, we transfer the copyright to the created software in the widest possible range allowed by law. In situations where full transfer of rights is not possible, we grant a non-exclusive, unlimited in time and territory license to use our works.

We have helped many clients who experienced the problem of "vendor lock-in" (dependency on a single supplier). Thanks to our policy, you are sure that no matter the scale of the project, you maintain full control over your product.`,
  ],
  'contact.faq.question12': [
    'Czy przygotowanie wyceny projektu jest płatne?',
    'Is preparing a project estimate paid?',
  ],
  'contact.faq.answer12': [
    `Przygotowanie wstępnej wyceny projektu jest zawsze bezpłatne. Pozwala ona zorientować się w przybliżonych kosztach i ramach czasowych.

Natomiast przygotowanie szczegółowej dokumentacji projektu jest usługą płatną. Obejmuje ona:
- Dogłębną analizę biznesową i techniczną Twojego pomysłu.
- Stworzenie kompleksowej dokumentacji projektowej.
- Opracowanie szczegółowego harmonogramu prac.

Dlaczego dokumentacja jest płatna? Ponieważ wymaga to znaczącego zaangażowania czasowego i pracy naszego zespołu ekspertów (analityków, projektantów UX/UI, architektów oprogramowania). Można to porównać do pracy architekta, który przygotowuje szczegółowy projekt budowlany domu. Otrzymując od nas taką dokumentację, możesz zrealizować projekt z nami lub z dowolną inną firmą. Decyzja należy do Ciebie.`,
    `Preparing a preliminary project estimate is always free. It allows you to orient yourself in approximate costs and time frames.

On the other hand, preparing a detailed project documentation is a paid service. It includes:
- Detailed business and technical analysis of your idea.
- Creation of a comprehensive project documentation.
- Development of a detailed work schedule.

Why is documentation paid? Because it requires significant time and work from our team of experts (analysts, UX/UI designers, software architects). You can compare it to the work of an architect who prepares a detailed building project. By receiving such documentation from us, you can implement the project with us or with any other company. The decision is yours.`,
  ],
  'contact.faq.question13': [
    'Czy udzielacie gwarancji na swoją pracę?',
    'Do you provide a guarantee for your work?',
  ],
  'contact.faq.answer13': [
    'Tak, bierzemy pełną odpowiedzialność za zrealizowane przez nas projekty. Jakość i niezawodność naszych rozwiązań są dla nas priorytetem. Umów się na spotkanie, aby poznać szczegóły.',
    'Yes, we take full responsibility for the projects we have implemented. The quality and reliability of our solutions are our priority. Schedule a meeting to learn more.',
  ],
  // Contact page
  'contact.hero.title': ['Skontaktuj się z nami', 'Contact us'],
  'contact.hero.subtitle': [
    'Masz pytania dotyczące naszych usług lub chcesz omówić swój projekt? Jesteśmy tutaj, aby Ci pomóc. Wybierz najwygodniejszą dla Ciebie formę kontaktu.',
    'Do you have questions about our services or want to discuss your project? We are here to help you. Choose the most convenient form of contact for you.',
  ],
  'contact.hero.button1': ['Umów spotkanie', 'Schedule a meeting'],
  'contact.hero.button2': ['Pokaż numer telefonu', 'Show phone number'],
  'contact.calendar.title': ['Zarezerwuj spotkanie online', 'Book an online meeting'],
  'contact.calculator.title': [
    'Wycena projektu w kilku prostych krokach',
    'Project estimation in a few simple steps',
  ],
  'contact.calculator.description': [
    'Chcesz szybko oszacować koszty swojego projektu? Skorzystaj z naszego kalkulatora wycen. Odpowiedz na kilka pytań, a my dostarczymy Ci wstępną kalkulację.',
    'Want to quickly estimate the cost of your project? Use our pricing calculator. Answer a few questions and we will provide you with a preliminary calculation.',
  ],
  'contact.calculator.button': ['Przejdź do kalkulatora wycen', 'Go to the pricing calculator'],
  'contact.calculator.step1': ['Krok 1', 'Step 1'],
  'contact.calculator.step1.description': ['Odpowiedz na kilka pytań.', 'Answer a few questions.'],
  'contact.calculator.step2': ['Krok 2', 'Step 2'],
  'contact.calculator.step2.description': [
    'Odbierz szacunkową wycenę!',
    'Receive an estimated quote!',
  ],
  'contact.faq.title': ['Najczęściej zadawane pytania', 'Frequently asked questions'],
  'contact.faq.description': [
    'Zebraliśmy najczęściej zadawane pytania, aby pomóc Ci lepiej zrozumieć naszą rolę w projekcie. Nie znajdujesz tutaj odpowiedzi na swoje pytanie? Zadzwoń do nas!',
    "We have collected the most frequently asked questions to help you better understand our role in the project. Don't find the answer to your question here? Call us!",
  ],

  // Footer
  'footer.company': ['Appotype sp. z o. o.', 'Appotype Ltd.'],
  'footer.address': ['ul. Kaleńska 5', 'Kalenska 5 St.'],
  'footer.city': ['04-367 Warszawa, Poland', '04-367 Warsaw, Poland'],
  'footer.workingHours': ['Godziny pracy', 'Working hours'],
  'footer.workingDays': ['poniedziałek-piątek', 'Monday-Friday'],
  'footer.workingTime': ['9:00 - 17:00', '9:00 AM - 5:00 PM'],
  'footer.timeZone': [
    'Central European Time (CET/CEST +1 or +2)',
    'Central European Time (CET/CEST +1 or +2)',
  ],
  'footer.general': ['Ogólne', 'General'],
  'footer.home': ['Strona główna', 'Home'],
  'footer.projects': ['Nasze realizacje', 'Our projects'],
  'footer.services': ['Usługi', 'Services'],
  'footer.about': ['O nas', 'About us'],
  'footer.contactForm': ['Formularz kontaktowy', 'Contact form'],
  'footer.videoCall': ['Umów Video rozmowę', 'Schedule video call'],
  'footer.calculator': ['Kalkulator wycen', 'Pricing calculator'],
  'footer.legal': ['Prawne', 'Legal'],
  'footer.privacy': ['Polityka prywatności', 'Privacy policy'],
  'footer.cookies': ['Cookies', 'Cookies'],
  'footer.copyright': [
    'Wszystkie prawa zastrzeżone 2025 | Appotype.eu',
    'All rights reserved 2025 | Appotype.eu',
  ],

  // Calculator component translations
  'calculator.step': ['Krok', 'Step'],
  'calculator.of': ['z', 'of'],
  'calculator.back': ['Wstecz', 'Back'],
  'calculator.next': ['Dalej', 'Next'],
  'calculator.submit': ['Wyślij', 'Submit'],

  'calculator.challenges.title': [
    'Jakie wyzwanie stoi przed Tobą?',
    'What challenge are you facing?',
  ],
  'calculator.challenges.subtitle': [
    'Wybierz opcję najlepiej opisującą Twój projekt',
    'Choose the option that best describes your project',
  ],
  'calculator.challenges.1': [
    'Przetestowanie pomysłu (Proof of concept)',
    'Testing the product idea (Proof of concept)',
  ],
  'calculator.challenges.2': [
    'Zbudować MVP (Minimalną Wersję Produktu)',
    'Build an MVP (Minimum Viable Product)',
  ],
  'calculator.challenges.3': [
    'Stworzyć zaawansowany produkt',
    'Create an advanced product',
  ],
  'calculator.challenges.4': [
    'Rozbudować istniejący produkt',
    'Expand an existing product',
  ],
  'calculator.challenges.5': [
    'Stworzyć system klasy korporacyjnej (Enterprise)',
    'Create a corporate system (Enterprise)',
  ],

  'calculator.services.title': [
    'Jakich usług potrzebujesz?',
    'What services do you need?',
  ],
  'calculator.services.subtitle': [
    'Wybierz wszystkie, które dotyczą Twojego projektu',
    'Select all that apply to your project',
  ],
  'calculator.services.1': [
    'Projektowanie wyglądu i funkcji aplikacji (UX/UI)',
    'Application design and functionality (UX/UI)',
  ],
  'calculator.services.2': ['Aplikacja mobilna', 'Mobile application'],
  'calculator.services.3': ['Aplikacja przeglądarkowa', 'Web application'],
  'calculator.services.4': [
    'Aplikacja desktopowa (tradycyjne oprogramowanie na komputer)',
    'Desktop application (traditional computer software)',
  ],
  'calculator.services.5': [
    'Wykorzystanie sztucznej inteligencji',
    'Artificial Intelligence',
  ],
  'calculator.services.6': [
    'Analiza danych (Data Science)',
    'Data analysis (Data Science)',
  ],
  'calculator.services.7': ['Chmura i zaplecze', 'Cloud and backend'],
  'calculator.services.8': [
    'Pomoc w rejestracji wyrobów medycznych',
    'Assistance in registering medical devices',
  ],

  'calculator.workshop.title': [
    'Gdzie jest główna siedziba Twojej firmy?',
    'Where is your company primarily located?',
  ],
  'calculator.workshop.subtitle': [
    'Pozwoli nam to lepiej dostosować warsztaty projektowe i zaplanować rozwój produktu do specyfiki rynku.',
    'This helps us tailor design workshops and development to your specific market.',
  ],
  'calculator.workshop.1': ['Polska', 'Poland'],
  'calculator.workshop.2': [
    'Europa (poza Polską)',
    'Europe (excluding Poland)',
  ],
  'calculator.workshop.3': [
    'USA',
    'USA',
  ],
  'calculator.workshop.4': [
    'Inne',
    'Other',
  ],

  'calculator.technologies.title': [
    'Opowiedz nam więcej o swoim projekcie',
    'Tell us more about your project',
  ],
  'calculator.technologies.subtitle': [
    'To pole jest opcjonalne.',
    'This field is optional.',
  ],
  'calculator.technologies.placeholder': [
    '',
    '',
  ],

  'calculator.estimate.title': [
    'Szacunkowy koszt projektu',
    'Estimated project cost',
  ],
  'calculator.estimate.subtitle': [
    'Podane wartości są przybliżone i mogą ulec zmianie po dokładnej analizie projektu.',
    'The values provided are approximate and may change after a detailed project analysis.',
  ],
  'calculator.estimate.exampleTitle': [
    'Przykładowy kosztorys',
    'Example cost estimate',
  ],
  'calculator.estimate.workshop': [
    'Przygotowanie i dokumentacja projektowa',
    'Project preparation and documentation',
  ],
  'calculator.estimate.tranches': [
    'Transze',
    'Tranches',
  ],
  'calculator.estimate.assumptions': [
    'Założenia projektowe',
    'Project assumptions',
  ],
  'calculator.estimate.development': [
    'Czas realizacji z zespołem',
    'Development time with team',
  ],
  'calculator.estimate.total': ['Razem', 'Total'],
  'calculator.estimate.vat': [
    '* Wszystkie ceny są netto (bez VAT)',
    '* All prices are net (without VAT)',
  ],
  'calculator.estimate.days': ['dni', 'days'],
  'calculator.estimate.months': ['miesięcy', 'months'],
  'calculator.estimate.month': ['miesiąc', 'month'],
  'calculator.estimate.teamMembers': ['Członkowie zespołu:', 'Team members:'],
  'calculator.estimate.milestones': ['Kamienie milowe', 'Milestones'],

  'calculator.contact.title': ['Podaj swój adres email', 'Enter your email address'],
  'calculator.contact.subtitle': [
    'Wyślemy Ci szczegółową wycenę i skontaktujemy się w sprawie projektu',
    "We'll send you a detailed quote and contact you about the project",
  ],
  'calculator.contact.email': ['Twój adres email', 'Your email address'],
  'calculator.contact.terms': [
    'Zgadzam się na kontakt mailowy w sprawie wyceny mojego projektu i akceptuję politykę prywatności',
    'I agree to email contact for my project quote and accept the privacy policy',
  ],

  'calculator.success.title': [
    'Dziękujemy za przesłanie formularza!',
    'Thank you for submitting the form!',
  ],
  'calculator.success.message': [
    'Twoja wycena została wysłana na podany adres email. Wkrótce skontaktujemy się z Tobą.',
    'Your quote has been sent to the provided email address. We will contact you shortly.',
  ],
  'calculator.success.return': ['Wróć do strony głównej', 'Return to home page'],

  'calculator.error.title': ['Wystąpił błąd', 'An error occurred'],
  'calculator.error.message': [
    'Nie udało się przesłać wyceny. Prosimy spróbować ponownie później lub skontaktować się z nami bezpośrednio.',
    'Failed to submit the quote. Please try again later or contact us directly.',
  ],
  'calculator.error.retry': ['Spróbuj ponownie', 'Try again'],

  // Team member titles
  'calculator.team.projectManager': ['Kierownik Projektu', 'Project Manager'],
  'calculator.team.designer': ['Projektant UI/UX', 'UI/UX Designer'],
  'calculator.team.developer': ['Programista', 'Developer'],
  'calculator.team.backendDev': ['Programista BE', 'Backend Developer'],
  'calculator.team.devops': ['Specjalista DevOps', 'DevOps Specialist'],
  'calculator.team.tester': ['Tester', 'Tester'],
  'calculator.team.mlEngineer': ['Inżynier ML', 'ML Engineer'],
  'calculator.team.consultant': ['Konsultant', 'Consultant'],

  // Privacy page
  'privacy.title': ['Polityka prywatności', 'Privacy Policy'],
  'privacy.subtitle': [
    'Tak samo, jak w innych serwisach internetowych - u nas również znajdziesz kilka akapitów formalności.',
    'Just like in other websites - here you will also find a few paragraphs of formalities.',
  ],
  'privacy.lastUpdated': [
    'Ostatnia aktualizacja 2 listopada 2022',
    'Last updated November 2, 2022',
  ],
  'privacy.intro': [
    'Niniejsza Polityka Prywatności opisuje politykę Appotype sp. z o. o., Kaleńska 5, mazowieckie 04-367 Warszawa, Polska, e-mail: contact@appotype.eu, telefon: +48 794 601 866 w zakresie gromadzenia, wykorzystywania i ujawniania Twoich informacji, które zbieramy podczas korzystania z naszej strony internetowej ("https://appotype.eu") ("Serwis"). Uzyskując dostęp lub korzystając z Serwisu, wyrażasz zgodę na gromadzenie, wykorzystywanie i inne przetwarzanie Twoich informacji zgodnie z niniejszą Polityką Prywatności. Jeśli nie zgadzasz się na to, prosimy nie uzyskiwać dostępu do Usługi ani z niej nie korzystać.',
    'This Privacy Policy describes the policy of Appotype sp. z o. o., Kaleńska 5, mazowieckie 04-367 Warsaw, Poland, e-mail: contact@appotype.eu, phone: +48 794 601 866 regarding the collection, use and disclosure of your information that we collect when you use our website ("https://appotype.eu") ("Service"). By accessing or using the Service, you agree to the collection, use and other processing of your information in accordance with this Privacy Policy. If you do not agree to this, please do not access or use the Service.',
  ],
  'privacy.changes': [
    'Możemy zmienić niniejszą Politykę Prywatności w dowolnym momencie bez powiadomienia. Twoje dalsze korzystanie z Usługi po wprowadzeniu zmian oznacza akceptację zmienionej Polityki Prywatności. Zmieniona Polityka będzie obowiązywać po 180 dniach od momentu zamieszczenia zmienionej Polityki Prywatności, a Twój dalszy dostęp lub korzystanie z Serwisu po tym czasie będzie oznaczać akceptację zmienionej Polityki Prywatności. Dlatego zalecamy okresowe przeglądanie tej strony.',
    'We may change this Privacy Policy at any time without notice. Your continued use of the Service after changes are made indicates your acceptance of the amended Privacy Policy. The amended Policy will be effective 180 days after the amended Privacy Policy is posted, and your continued access to or use of the Service after that time will constitute acceptance of the amended Privacy Policy. Therefore, we recommend that you review this page periodically.',
  ],
  'privacy.howWeUse.title': [
    'Jak wykorzystujemy Twoje informacje:',
    'How we use your information:',
  ],
  'privacy.howWeUse.intro': [
    'Będziemy wykorzystywać informacje, które zbieramy o Tobie do następujących celów:',
    'We will use the information we collect about you for the following purposes:',
  ],
  'privacy.howWeUse.list.1': [
    'Zbieranie informacji zwrotnych od klientów',
    'Collecting customer feedback',
  ],
  'privacy.howWeUse.list.2': ['Udoskonalanie Serwisu', 'Improving the Service'],
  'privacy.howWeUse.list.3': ['Wsparcie', 'Support'],
  'privacy.howWeUse.permission': [
    'Jeśli będziemy chcieli wykorzystać informacje o użytkowniku w innym celu, poprosimy go o zgodę i wykorzystamy informacje tylko po otrzymaniu zgody, a następnie tylko w celu (celach), na który udzielono zgody, chyba że prawo będzie wymagało od nas innego postępowania.',
    'If we want to use user information for another purpose, we will ask for consent and use the information only after receiving consent, and then only for the purpose(s) for which consent was given, unless the law requires us to act otherwise.',
  ],
  'privacy.howWeShare.title': [
    'Jak udostępniamy Twoje informacje:',
    'How we share your information:',
  ],
  'privacy.howWeShare.intro': [
    'Nie będziemy przekazywać Państwa danych osobowych żadnym stronom trzecim bez uzyskania Państwa zgody, z wyjątkiem ograniczonych okoliczności opisanych poniżej:',
    'We will not transfer your personal data to any third parties without your consent, except in the limited circumstances described below:',
  ],
  'privacy.howWeShare.list.1': ['Analiza ruchu w Serwisie', 'Service traffic analysis'],
  'privacy.howWeShare.thirdParties': [
    'Wymagamy od stron trzecich, aby wykorzystywały dane osobowe, które im przekazujemy, wyłącznie w celu, w którym zostały przekazane, i nie przekazywały ich dalej niż jest to wymagane do realizacji wspomnianego celu.',
    'We require third parties to use personal data that we disclose to them solely for the purpose for which it was disclosed and not to transfer it further than is required to accomplish that purpose.',
  ],
  'privacy.howWeShare.disclosure': [
    'Możemy również ujawnić dane osobowe użytkownika w następujących przypadkach: (1) przestrzegania obowiązującego prawa, regulacji, nakazu sądowego lub innego procesu prawnego; (2) egzekwowania umów z nami, w tym niniejszej Polityki prywatności; lub (3) reagowania na roszczenia, że korzystanie z Usługi przez użytkownika narusza jakiekolwiek prawa osób trzecich. Jeśli Serwis lub nasza firma zostanie połączona lub nabyta przez inną firmę, informacje o użytkowniku będą jednym z aktywów, które zostaną przekazane nowemu właścicielowi.',
    "We may also disclose a user's personal data in the following cases: (1) to comply with applicable law, regulations, court order, or other legal process; (2) to enforce our agreements, including this Privacy Policy; or (3) to respond to claims that a user's use of the Service violates any third-party rights. If the Service or our company is merged with or acquired by another company, user information will be one of the assets transferred to the new owner.",
  ],
  'privacy.rights.title': ['Twoje prawa:', 'Your rights:'],
  'privacy.rights.access': [
    'W zależności od obowiązującego prawa, możesz mieć prawo do dostępu i sprostowania lub usunięcia swoich danych osobowych lub otrzymania kopii swoich danych osobowych, ograniczenia lub sprzeciwu wobec aktywnego przetwarzania Twoich danych, zwrócenia się do nas o udostępnienie (przeniesienie) Twoich danych osobowych innemu podmiotowi, wycofania wszelkich zgód, których udzieliłeś nam na przetwarzanie Twoich danych, prawo do złożenia skargi do organu ustawowego oraz takie inne prawa, które mogą być istotne w świetle obowiązujących przepisów. Aby skorzystać z tych praw, możesz napisać do nas na adres contact@appotype.eu. Odpowiemy na Twój wniosek zgodnie z obowiązującym prawem.',
    'Depending on applicable law, you may have the right to access and correct or delete your personal data or receive a copy of your personal data, restrict or object to the active processing of your data, ask us to disclose (transfer) your personal data to another entity, withdraw any consents you have given us for the processing of your data, the right to lodge a complaint with a statutory authority, and such other rights as may be relevant under applicable laws. To exercise these rights, you can write to us at contact@appotype.eu. We will respond to your request in accordance with applicable law.',
  ],
  'privacy.rights.notice': [
    'Należy pamiętać, że jeśli nie zezwolą nam Państwo na gromadzenie lub przetwarzanie wymaganych danych osobowych lub wycofają zgodę na ich przetwarzanie w wymaganych celach, mogą Państwo nie mieć dostępu lub nie móc korzystać z usługi, dla której te dane są niezbędne.',
    'Please note that if you do not allow us to collect or process required personal data or withdraw consent to process it for required purposes, you may not have access to or be able to use the service for which the data is necessary.',
  ],
  'privacy.rights.cookies': [
    'Aby dowiedzieć się więcej o tym, jak je wykorzystujemy i jakie są Twoje wybory w odniesieniu do tych technologii śledzenia, zapoznaj się z naszą Polityką dotyczącą plików cookie.',
    'To learn more about how we use them and what your choices are regarding these tracking technologies, please see our Cookie Policy.',
  ],
  'privacy.security.title': ['Bezpieczeństwo:', 'Security:'],
  'privacy.security.measures': [
    'Bezpieczeństwo Państwa informacji jest dla nas ważne i będziemy stosować rozsądne środki bezpieczeństwa, aby zapobiec utracie, niewłaściwemu wykorzystaniu lub nieautoryzowanej zmianie Państwa informacji pod naszą kontrolą. Jednakże, biorąc pod uwagę specyfikację ryzyka, nie możemy zagwarantować całkowitego bezpieczeństwa informacji. W szczególności informacji nie można zapewnić ani zagwarantować bezpieczeństwa jakichkolwiek informacji, które nam Państwo przekazują, a Państwo czynią to na własne ryzyko.',
    'The security of your information is important to us and we will apply reasonable security measures to prevent loss, misuse or unauthorized alteration of your information under our control. However, given the specification of risk, we cannot guarantee the complete security of information. In particular, we cannot ensure or guarantee the security of any information that you transmit to us, and you do so at your own risk.',
  ],
  'privacy.thirdParty.title': [
    'Linki stron trzecich i wykorzystanie Twoich informacji:',
    'Third party links and use of your information:',
  ],
  'privacy.thirdParty.content': [
    'Nasz Serwis może zawierać linki do innych stron internetowych, które nie są przez nas obsługiwane. Niniejsza Polityka Prywatności nie odnosi się do polityki prywatności i innych praktyk stosowanych przez osoby trzecie, w tym osoby trzecie obsługujące jakąkolwiek stronę internetową lub usługę, która może być dostępna poprzez link w Serwisie. Zalecamy zapoznanie się z polityką prywatności każdej odwiedzanej strony. Nie mamy kontroli i nie ponosimy odpowiedzialności za treść, politykę prywatności ani praktyki stosowane przez jakiekolwiek strony lub usługi osób trzecich.',
    'Our Service may contain links to other websites that are not operated by us. This Privacy Policy does not apply to the privacy policies and other practices of third parties, including third parties operating any website or service that may be accessible via a link in the Service. We recommend that you review the privacy policy of each site you visit. We have no control over and assume no responsibility for the content, privacy policies or practices of any third party sites or services.',
  ],
  'privacy.questions.title': ['Jeżeli masz pytania:', 'If you have questions:'],
  'privacy.questions.contact': [
    'Jeśli masz jakiekolwiek pytania lub wątpliwości dotyczące przetwarzania Twoich danych, które są u nas dostępne, możesz wysłać e-mail do naszego Inspektora ochrony danych osobowych, Mateusz Chechliński.m@appotype.eu. Zajmiemy się Twoimi zastrzeżeniami zgodnie z obowiązującym prawem.',
    'If you have any questions or concerns about the processing of your data that are available to us, you can email our Data Protection Officer, Mateusz Chechliński.m@appotype.eu. We will address your concerns in accordance with applicable law.',
  ],

  // Cookies page
  'cookies.title': ['Cookies', 'Cookies'],
  'cookies.subtitle': [
    'Dowiedz się więcej o tym, jak wykorzystujemy pliki cookie i jakie są Twoje wybory w odniesieniu do tych technologii śledzenia.',
    'Learn more about how we use cookies and what your choices are regarding these tracking technologies.',
  ],
  'cookies.manageSettings': [
    'W każdej chwili możesz zaktualizować swoje ustawienia klikając w ten link.',
    'You can update your settings by clicking on this link at any time.',
  ],
  'cookies.lastUpdated': [
    'Ostatnia aktualizacja 2 listopada 2022',
    'Last updated November 2, 2022',
  ],
  'cookies.intro': [
    'Niniejsza Polityka dotycząca plików cookie wyjaśnia, czym są pliki cookie i jak je wykorzystujemy. Powinieneś przeczytać tę politykę, aby zrozumieć, jakiego rodzaju plików cookie używamy, jakie informacje zbieramy za pomocą plików cookie i jak te informacje są wykorzystywane na stronie https://appotype.eu.',
    'This Cookie Policy explains what cookies are and how we use them. You should read this policy to understand what kinds of cookies we use, what information we collect using cookies and how that information is used on the https://appotype.eu website.',
  ],
  'cookies.whatAre.title': ['Czym są pliki cookie?', 'What are cookies?'],
  'cookies.whatAre.content': [
    'Pliki cookie to małe pliki tekstowe, które są używane do przechowywania małych fragmentów informacji. Pliki cookie są przechowywane na Twoim urządzeniu, gdy strona internetowa jest ładowana w przeglądarce. Te pliki cookie pomagają nam w prawidłowym funkcjonowaniu witryny, zwiększają jej bezpieczeństwo, zapewniają lepsze wrażenia użytkownika i pomagają nam zrozumieć, jak witryna działa i analizować, co działa, a co wymaga naprawy.',
    'Cookies are small text files that are used to store small pieces of information. Cookies are stored on your device when the website is loaded in your browser. These cookies help us make the website function properly, make it more secure, provide a better user experience, and help us understand how the website works and analyze what works and what needs fixing.',
  ],
  'cookies.howWeUse.title': ['Jak używamy plików cookie?', 'How do we use cookies?'],
  'cookies.howWeUse.content': [
    'Podobnie jak większość usług online, nasza witryna używa plików cookie pierwszej i trzeciej kategorii do kilku celów. Pliki cookie pierwszej kategorii to głównie niezbędne pliki cookie do podstawowych funkcji witryny, a także pliki cookie analityczne, które pomagają nam analizować sposób korzystania z witryny i poprawiać wrażenia użytkownika.',
    'Like most online services, our website uses first-party and third-party cookies for several purposes. First-party cookies are mainly necessary cookies for the basic functionality of the website, as well as analytical cookies that help us analyze how the website is used and improve the user experience.',
  ],
  'cookies.types.necessary': [
    'Niezbędne pliki cookie: Niektóre pliki cookie są niezbędne, abyś mógł korzystać z podstawowych funkcji witryny.',
    'Necessary cookies: Some cookies are essential for you to be able to use the basic functions of the website.',
  ],
  'cookies.types.analytics': [
    'Analityczne pliki cookie: Używamy tych plików cookie do śledzenia wydajności i użytkowania naszej witryny.',
    'Analytical cookies: We use these cookies to track the performance and usage of our website.',
  ],
  'cookies.types.functional': [
    'Funkcjonalne pliki cookie: Te pliki cookie pomagają nam zapamiętać Twoje preferencje i ustawienia.',
    'Functional cookies: These cookies help us remember your preferences and settings.',
  ],
  'cookies.choices.title': ['Twoje wybory dotyczące plików cookie', 'Your cookie choices'],
  'cookies.choices.content': [
    'Różne przeglądarki oferują różne metody zarządzania ustawieniami plików cookie. Możesz zablokować lub usunąć niektóre lub wszystkie pliki cookie. Jeśli zdecydujesz się zmienić ustawienia plików cookie, możesz mieć wpływ na sposób działania naszej witryny. Niektóre usługi mogą przestać działać, a inne funkcje mogą nie działać prawidłowo.',
    'Different browsers offer different methods of managing cookie settings. You can block or delete some or all cookies. If you decide to change your cookie settings, you may affect how our website works. Some services may stop working, and other functions may not work properly.',
  ],
  'cookies.contact.title': ['Kontakt', 'Contact'],
  'cookies.contact.content': [
    'Jeśli masz jakiekolwiek pytania dotyczące naszej Polityki dotyczącej plików cookie, skontaktuj się z nami pod adresem contact@appotype.eu.',
    'If you have any questions about our Cookie Policy, please contact us at contact@appotype.eu.',
  ],

  // Cookie Consent component
  'cookieConsent.title': ['Zgoda na ciasteczka', 'Cookie Consent'],
  'cookieConsent.description': [
    'Nasza strona wykorzystuje ciasteczka. Klikając "Akceptuję", zgadzasz się na ich użycie. Więcej informacji znajdziesz w naszej',
    'Our website uses cookies. By clicking "Accept", you agree to their use. You can find more information in our',
  ],
  'cookieConsent.privacyLink': ['Polityce Prywatności', 'Privacy Policy'],
  'cookieConsent.customizeButton': ['Dostosuj ustawienia', 'Customize settings'],
  'cookieConsent.acceptButton': ['Akceptuję', 'Accept'],
  'cookieConsent.acceptAllButton': ['Akceptuj wszystkie', 'Accept all'],
  'cookieConsent.acceptSelectedButton': ['Akceptuj wybrane', 'Accept selected'],

  'cookieConsent.necessary': ['Niezbędne', 'Necessary'],
  'cookieConsent.functional': ['Funkcjonalne', 'Functional'],
  'cookieConsent.analytics': ['Analityczne', 'Analytics'],
  'cookieConsent.performance': ['Wydajnościowe', 'Performance'],
  'cookieConsent.advertising': ['Reklamowe', 'Advertising'],

  'cookieConsent.tooltip.necessary': [
    'Niezbędne pliki cookie są wymagane do włączenia podstawowych funkcji tej witryny, takich jak zapewnienie bezpiecznego logowania lub dostosowanie preferencji zgody. Te pliki cookie nie przechowują żadnych danych umożliwiających identyfikację użytkownika.',
    'Necessary cookies are required to enable basic functions of this website, such as ensuring secure login or customizing consent preferences. These cookies do not store any personally identifiable information.',
  ],
  'cookieConsent.tooltip.functional': [
    'Funkcjonalne pliki cookie pomagają w wykonywaniu określonych funkcji, takich jak udostępnianie zawartości witryny na platformach mediów społecznościowych, zbieranie informacji zwrotnych i inne funkcje innych firm.',
    'Functional cookies help perform certain functions, such as sharing website content on social media platforms, collecting feedback, and other third-party features.',
  ],
  'cookieConsent.tooltip.analytics': [
    'Analityczne pliki cookie służą do zrozumienia, w jaki sposób odwiedzający wchodzą w interakcję z witryną. Te pliki cookie pomagają dostarczać informacje o metrykach liczby odwiedzających, współczynniku odrzuceń, źródle ruchu itp.',
    'Analytical cookies are used to understand how visitors interact with the website. These cookies help provide information about metrics such as visitor count, bounce rate, traffic source, etc.',
  ],
  'cookieConsent.tooltip.performance': [
    'Wydajnościowe pliki cookie służą do zrozumienia i analizy kluczowych wskaźników wydajności witryny, co pomaga zapewnić lepsze wrażenia użytkownika dla odwiedzających.',
    'Performance cookies are used to understand and analyze key performance indicators of the website, which helps provide a better user experience for visitors.',
  ],
  'cookieConsent.tooltip.advertising': [
    'Reklamowe pliki cookie służą do dostarczania odwiedzającym odpowiednich reklam i kampanii marketingowych. Te pliki cookie śledzą odwiedzających w witrynach i zbierają informacje w celu dostarczania dostosowanych reklam.',
    'Advertising cookies are used to deliver relevant advertisements and marketing campaigns to visitors. These cookies track visitors across websites and collect information to provide customized ads.',
  ],

  // Enterprise Page additional translations
  'enterprise.howWeWork.step2.title': ['Nadzór autorski', 'Authoritative supervision'],
  'enterprise.howWeWork.step2.description1': [
    'Nadzór autorski to wsparcie na każdym etapie realizacji projektu. Zapewniamy zgodność z dokumentacją projektową i pierwotnymi założeniami.',
    'Authoritative supervision is support at every stage of project implementation. We ensure compliance with project documentation and initial assumptions.',
  ],
  'enterprise.howWeWork.step2.description2': [
    'Nasi specjaliści monitorują postęp prac, efektywnie komunikują się z wykonawcami. Dbamy o to, by wszelkie zmiany były wprowadzane zgodnie z planem i Twoimi oczekiwaniami.',
    'Our experts monitor the progress of work, effectively communicate with executors. We ensure that all changes are made in accordance with the plan and your expectations.',
  ],
  'enterprise.howWeWork.step2.description3': [
    'Zapewniamy, że projekt będzie zgodny z Twoją wizją.',
    'We ensure that the project will be in line with your vision.',
  ],

  'enterprise.howWeWork.step3.title': ['Nadzór inwestorski', 'Investor supervision'],
  'enterprise.howWeWork.step3.description1': [
    'Nadzór inwestorski to kontrola jakości, terminowości i zgodności z budżetem. Nasi specjaliści aktywnie monitorują postęp prac Twojego podwykonawcy. Dbamy o to, by wszelkie modyfikacje były konsultowane i zgodne z Twoimi interesami jako inwestora.',
    'Investor supervision is quality control, timeliness, and compliance with the budget. Our experts actively monitor the progress of work of your subcontractor. We ensure that all modifications are consulted and in line with your interests as an investor.',
  ],
  'enterprise.howWeWork.step3.description2': [
    'Decydując się na tę usługę zyskujesz niezależnego konsultanta, który stoi na straży Twoich interesów.',
    'By choosing this service, you get an independent consultant who stands by your interests.',
  ],

  'enterprise.howWeWork.step4.title': ['Doradztwo technologiczne', 'Technology consulting'],
  'enterprise.howWeWork.step4.description1': [
    'Udzielamy eksperckiego wsparcia w wyborze optymalnych rozwiązań technologicznych. Analizujemy Twoje potrzeby i dopasowujemy narzędzia do strategicznych celów Twojej organizacji.',
    'We offer expert support in choosing optimal technological solutions. We analyze your needs and match tools to the strategic goals of your organization.',
  ],
  'enterprise.howWeWork.step4.description2': [
    'Pomagamy podejmować świadome decyzje technologiczne. W efekcie nasi klienci znacząco skracają czas potrzebny na wdrożenie nowych rozwiązań i osiągnięcie kluczowych celów biznesowych.',
    'We help make informed technology decisions. As a result, our clients significantly reduce the time needed to implement new solutions and achieve key business goals.',
  ],
  'enterprise.howWeWork.step4.description3': [
    'Przy niektórych projektach skróciliśmy czas realizacji MVP nawet o 25%.',
    'In some projects, we reduced the time to implement MVP by up to 25%.',
  ],

  // SoftwareAgency Page additional translations
  'softwareAgency.howWeWork.step3.title': [
    'Oprogramowanie do urządzeń IoT',
    'Software for IoT devices',
  ],
  'softwareAgency.howWeWork.step3.description1': [
    'Projektujemy i wdrażamy oprogramowanie dla urządzeń IoT. Płynnie integrujemy inteligentne systemy, które umożliwiają zaawansowane zbieranie i analizę danych w czasie rzeczywistym.',
    'We design and implement software for IoT devices. We seamlessly integrate intelligent systems that enable advanced data collection and analysis in real time.',
  ],
  'softwareAgency.howWeWork.step3.description2': [
    'Wykorzystaj potencjał IoT do optymalizacji procesów i zwiększenia efektywności Twojej firmy.',
    'Utilize the potential of IoT to optimize processes and increase the efficiency of your business.',
  ],

  'softwareAgency.howWeWork.step4.title': [
    'Nietypowe projekty oprogramowania',
    'Unusual software projects',
  ],
  'softwareAgency.howWeWork.step4.description1': [
    'Zajmujemy się realizacją nietypowych projektów software’owych. Jeżeli potrzebujesz kreatywnego rozwiązania trudnych problemów projektowych, to ta usługa jest dla Ciebie.',
    'We are involved in the implementation of unusual software projects. If you need a creative solution to difficult project problems, this service is for you.',
  ],
  'softwareAgency.howWeWork.step4.description2': [
    'Dzięki naszemu doświadczeniu, pomożemy Ci w doborze optymalnych rozwiązań i sprawnym wdrożeniu Twojej unikalnej wizji na rynek.',
    'Thanks to our experience, we will help you choose the optimal solutions and implement your unique vision on the market.',
  ],

  // Enterprise nextSteps
  'enterprise.nextSteps.step1': [
    'Przeprowadzamy analizę Twoich systemów i wymagań biznesowych',
    'We analyze your systems and business requirements',
  ],
  'enterprise.nextSteps.step2': [
    'Przygotowujemy dostosowaną strategię technologiczną',
    'We prepare a customized technology strategy',
  ],
  'enterprise.nextSteps.step3': [
    'Wdrażamy rozwiązania z pełnym wsparciem i dokumentacją',
    'We implement solutions with full support and documentation',
  ],

  // Enterprise recognition
  'enterprise.recognition.subtitle1': [
    'Jako partner technologiczny, dążymy do budowania długoterminowych relacji opartych na wzajemnym zaufaniu i zrozumieniu potrzeb biznesowych.',
    'As a technology partner, we strive to build long-term relationships based on mutual trust and understanding of business needs.',
  ],
  'enterprise.recognition.subtitle2': [
    'Oferujemy nie tylko wsparcie techniczne, ale również strategiczne doradztwo, które pomaga naszym klientom podejmować świadome decyzje technologiczne.',
    'We offer not only technical support but also strategic consulting that helps our clients make informed technology decisions.',
  ],
  'enterprise.recognition.title': [
    'Strategiczne partnerstwo dla sukcesu IT',
    'Strategic partnership for IT success',
  ],

  // SoftwareAgency specific translations
  'softwareAgency.recognition.title': [
    'Partnerstwo, które napędza Twój wzrost',
    'Partnership that drives your growth',
  ],

  // Enterprise caseStudy
  'enterprise.caseStudy.title': [
    'Przykłady naszych wdrożeń dla firm korporacyjnych',
    'Examples of our implementations for corporate clients',
  ],

  // SoftwareAgency caseStudy
  'softwareAgency.caseStudy.title': [
    'Projekty, które z sukcesem wdrożyliśmy',
    'Projects we have successfully implemented',
  ],

  'enterprise.industry.card1': [
    'Potrzebujesz strategicznego partnera IT',
    'You need a strategic IT partner',
  ],
  'enterprise.industry.card2': [
    'Szukasz eksperta do audytu i optymalizacji',
    "You're looking for an expert for audit and optimization",
  ],
  'enterprise.industry.card3': [
    'Wymagasz niezawodnego wsparcia technicznego',
    'You require reliable technical support',
  ],

  'enterprise.howWeWork.step1.title': ['Przeprowadzamy Audyty IT', 'We conduct IT audits'],
  'enterprise.howWeWork.step1.description1': [
    'Audyt IT to szczegółowa analiza systemów, która pozwala na identyfikację słabych punktów w infrastrukturze oraz bezpieczeństwie.',
    'IT audit is a detailed analysis of systems that allows for identifying weaknesses in the infrastructure and security.',
  ],
  'enterprise.howWeWork.step1.description2': [
    'W oparciu o audyt, przedstawimy Ci jasne rekomendacje i konkretne rozwiązania. Realnie zwiększysz wydajność operacyjną i poziom zabezpieczeń Twojego biznesu.',
    'Based on the audit, we will present you with clear recommendations and specific solutions. You will actually increase your operational efficiency and the level of security of your business.',
  ],
  'enterprise.howWeWork.step1.description3': [
    'Nasze rekomendacje pozwalają zoptymalizować działanie i zwiększyć wydajność nawet o 40%.',
    'Our recommendations allow you to optimize operations and increase efficiency by up to 40%.',
  ],

  'enterprise.cards.title1': [
    'Zwiększenie efektywności procesów IT',
    'Increase IT process efficiency',
  ],
  'enterprise.cards.description1': [
    'Wdrażamy inteligentne technologie, które usprawniają kluczowe procesy w Twojej organizacji. W ten sposób dbamy o wzrost produktywności i szybszą realizację celów biznesowych.',
    'We implement intelligent technologies that streamline key processes in your organization. In this way, we ensure increased productivity and faster achievement of business goals.',
  ],
  'enterprise.cards.title2': ['Minimalizacja ryzyka projektowego', 'Minimize project risk'],
  'enterprise.cards.description2': [
    'Dzięki wiedzy i doświadczeniu minimalizujemy ryzyko technologiczne, pomagając Ci unikać czasochłonnych poprawek.',
    'Thanks to knowledge and experience, we minimize technological risk, helping you avoid time-consuming corrections.',
  ],
  'enterprise.cards.title3': ['Obniżenie kosztów operacyjnych', 'Reduce operational costs'],
  'enterprise.cards.description3': [
    'Dostosowujemy rozwiązania IT, które nie tylko działają efektywnie, ale również pomagają obniżyć koszty operacyjne w długiej perspektywie.',
    'We tailor IT solutions that not only work efficiently but also help reduce operational costs in the long term.',
  ],
  'enterprise.cards.title4': [
    'Zwiększenie jakości i bezpieczeństwa projektów',
    'Increase project quality and security',
  ],
  'enterprise.cards.description4': [
    'Nasze narzędzia i metody zarządzania projektami pomagają Ci osiągać wysoką jakość na każdym etapie wdrożenia technologii.',
    'Our tools and project management methods help you achieve high quality at each stage of technology implementation.',
  ],
  'enterprise.cards.title5': [
    'Dostosowanie technologii do celów biznesowych',
    'Tailoring technology to business goals',
  ],
  'enterprise.cards.description5': [
    'Dobieramy technologie tak, aby idealnie wspierały rozwój Twojego biznesu i przyspieszały realizację celów.',
    'We select technologies that perfectly support the development of your business and accelerate the achievement of goals.',
  ],
  'enterprise.cards.title6': [
    'Transparentność i kontrola nad projektem',
    'Transparency and project control',
  ],
  'enterprise.cards.description6': [
    'Zapewniamy pełną przejrzystość działań, informując Cię o postępach i wyjaśniając każdy krok wdrożenia technologii.',
    'We ensure full transparency of actions, informing you about progress and explaining each step of technology implementation.',
  ],

  'softwareAgency.howWeWork.step1.title': [
    'Aplikacje mobilne i webowe',
    'Mobile and web applications',
  ],
  'softwareAgency.howWeWork.step1.description1': [
    'Tworzymy nowoczesne aplikacje, które doskonale balansują między potrzebami użytkowników, a celami biznesowymi naszych klientów.',
    'We create modern applications that perfectly balance the needs of users with the business goals of our clients.',
  ],
  'softwareAgency.howWeWork.step1.description2': [
    'Specjalizujemy się w projektowaniu UX/UI i dbaniu o wysoką skalowalność każdego produktu. Dzięki naszemu know-how, aplikacje szybciej trafiają na rynek.',
    'We specialize in UX/UI design and focus on high scalability of each product. Thanks to our know-how, applications are released faster on the market.',
  ],

  'softwareAgency.howWeWork.step2.title': [
    'Zaawansowane aplikacje serwerowe',
    'Advanced server applications',
  ],
  'softwareAgency.howWeWork.step2.description1': [
    'Specjalizujemy się w budowie zaawansowanych aplikacji, które obsługują duże ilości danych. Takie rozwiązania zapewniają niezawodność w kluczowych procesach biznesowych.',
    'We specialize in building advanced applications that handle large amounts of data. Such solutions ensure reliability in key business processes.',
  ],
  'softwareAgency.howWeWork.step2.description2': [
    'Wydajne aplikacje serwerowe to podstawa działania Twojego systemu. Zadbamy o optymalizację wydajności i najwyższe standardy bezpieczeństwa Twojego backendu.',
    'Efficient server applications are the foundation of your system. We will take care of optimizing performance and the highest security standards for your backend.',
  ],

  'softwareAgency.cards.title1': [
    'Oszczędzasz czas i unikasz zbędnych kosztów',
    'You save time and avoid unnecessary costs',
  ],
  'softwareAgency.cards.description1': [
    'Wprowadzamy technologie, które usprawniają kluczowe procesy w Twojej firmie, co przekłada się na szybszy rozwój.',
    'We introduce technologies that streamline key processes in your company, which translates into faster growth.',
  ],
  'softwareAgency.cards.title2': [
    'Automatyzujesz i skalujesz procesy', 
    'You automate and scale processes',
  ],
  'softwareAgency.cards.description2': [
    'Dzięki naszej wiedzy i doświadczeniu minimalizujemy ryzyko technologiczne. Pomożemy Ci unikać czasochłonnych błędów.',
    'Thanks to our knowledge and experience, we minimize technological risk. We will help you avoid time-consuming errors.',
  ],
  'softwareAgency.cards.title3': [
    'Zwiększasz swoją przewagę na rynku',
    'You increase your market advantage',
  ],
  'softwareAgency.cards.description3': [
    'Tworzymy rozwiązania IT, które nie tylko działają efektywnie, ale znacznie redukują dług technologiczny. W dłuższej perspektywie przekłada sie to na obniżenie kosztów operacyjnych.',
    'We create IT solutions that not only work efficiently but also significantly reduce the technological debt. In the long term, this translates into reduced operational costs.',
  ],

  'softwareAgency.nextSteps.step1': [
    'Ustalamy cele i wymagania Twojego projektu',
    'We establish the goals and requirements of your project',
  ],
  'softwareAgency.nextSteps.step2': [
    'Opracowujemy harmonogram i plan działania',
    'We develop a schedule and action plan',
  ],
  'softwareAgency.nextSteps.step3': [
    'Realizujemy projekt z ciągłą komunikacją i raportowaniem',
    'We implement the project with continuous communication and reporting',
  ],

  'softwareAgency.recognition.subtitle1': [
    'W Appotype podchodzimy do każdego projektu, jak do strategicznego partnerstwa. Wierzymy, że najlepsze rozwiązania powstają w oparciu o zaufanie. Nie jesteśmy tylko wykonawcą. Angażujemy się w zrozumienie Twojego biznesu, aby wspólnie odkrywać i wdrażać innowacyjne technologie.',
    "We approach each project as a strategic partnership. We believe that the best solutions are created based on trust. We are not just executors. We are involved in understanding your business to jointly discover and implement innovative technologies.",
  ],
  'softwareAgency.recognition.subtitle2': [
    'Wspólnie krok po kroku tworzymy spersonalizowaną roadmapę dopasowaną do Twoich celów. W ten sposób budujemy solidny fundament długofalowej współpracy.',
    'Together, step by step, we create a personalized roadmap tailored to your goals. In this way, we build a solid foundation for long-term cooperation.',
  ],
};

/**
 * Get a translation by key based on the current language
 * @param key The translation key to look up
 * @param language The current language ('pl' or 'en')
 * @returns The translated text
 */
export const getTranslation = (key: TranslationKey, language: 'pl' | 'en'): string => {
  const translationPair = translations[key];

  if (!translationPair) {
    console.warn(`Translation key not found: ${key}`);
    return key;
  }

  return language === 'pl' ? translationPair[0] : translationPair[1];
};
